<template>
  <div class="basic-info">
    <div class="basic-info-container">
      <el-form :model="form" ref="form" label-width="auto" size="mini" :rules="addRules"
        :disabled="formDisabled || mode === 'view'">
        
        <!-- 整个表单的滚动容器 -->
        <div class="form-scroll-container" v-if="dynamicFields.length > 0">
          
          <!-- 第一行：药品基础信息 -->
          <el-row :gutter="6" class="required-fields-row first-required-row">
            <!-- 药品名称 col=8 -->
            <el-col :span="6" v-if="showRequiredField('drugName')">
              <el-form-item 
                label="药品名称：" 
                prop="drugName"
                :rules="getFieldRequiredRules('drugName')"
                class="form-item-compact form-item-adaptive">
                <el-input 
                  v-model="form.drugName"
                  placeholder="请输入药品名称"
                  @blur="handleFieldBlur({fieldCode: 'drugName'})"
                  @input="handleFieldInput({fieldCode: 'drugName'}, $event)"
                  :disabled="getFieldDisabledByCode('drugName')" 
                  clearable
                  class="compact-input">
                </el-input>
              </el-form-item>
            </el-col>
			<!-- 包装数量 col=4 -->
			<el-col :span="6" v-if="showRequiredField('pacCnt')">
			    <el-form-item 
			      label="包装数量：" 
			      prop="pacCnt"
			      :rules="getFieldRequiredRules('pacCnt')"
			      class="form-item-compact form-item-adaptive">
			      <el-input 
			        v-model="form.pacCnt"
			        placeholder="请输入包装数量"
			        @blur="handleFieldBlur({fieldCode: 'pacCnt'})"
			        @input="handleFieldInput({fieldCode: 'pacCnt'}, $event)"
			        :disabled="getFieldDisabledByCode('pacCnt')" 
			        clearable
			        class="compact-input">
			      </el-input>
			    </el-form-item>
			</el-col>
            <!-- 包装单位 col=6 -->
            <el-col :span="6" v-if="showRequiredField('pacUnt')">
              <el-form-item 
                label="包装单位：" 
                prop="pacUnt"
                :rules="getFieldRequiredRules('pacUnt')"
                class="form-item-compact form-item-adaptive">
                <!-- 包装单位下拉框 -->
                <el-select 
                  v-model="form.pacUnt"
                  placeholder="请选择包装单位"
                  @change="handlePacUntChange($event)"
                  :disabled="getFieldDisabledByCode('pacUnt')"
                  filterable
                  clearable
                  class="compact-select pac-unt-select"
                  popper-class="custom-unit-dropdown">
                  <el-option
                    v-for="option in allUnitOptions"
                    :key="option.id"
                    :label="option.label"
                    :value="option.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
			
            
			<!-- 最小单位 col=6 -->
			<el-col :span="getThirdRowColSpan()" v-if="showRequiredField('minUnt')">
			  <el-form-item 
			    label="最小单位：" 
			    prop="minUnt"
			    :rules="getFieldRequiredRules('minUnt')"
			    class="form-item-compact form-item-adaptive">
			    <el-select 
			      v-model="form.minUnt"
			      placeholder="请选择最小单位"
			      @change="handleMinUntChange($event)"
			      :disabled="getFieldDisabledByCode('minUnt')"
			      filterable
			      clearable
			      class="compact-select min-unt-select"
			      popper-class="custom-unit-dropdown">
			      <el-option
			        v-for="option in allUnitOptions"
			        :key="option.id"
			        :label="option.label"
			        :value="option.id"></el-option>
			    </el-select>
			  </el-form-item>
			</el-col>
          </el-row>
          
          <!-- 第二行：单位信息 -->
          <el-row :gutter="8" class="required-fields-row second-required-row">
            <!-- 药品编码 col=6 -->
            <el-col :span="6" v-if="showRequiredField('code')">
              <el-form-item 
                label="药品编码：" 
                prop="code"
                :rules="getFieldRequiredRules('code')"
                class="form-item-compact form-item-adaptive">
                <el-input 
                  v-model="form.code"
                  placeholder="请输入药品编码"
                  @blur="handleFieldBlur({fieldCode: 'code'})"
                  @input="handleFieldInput({fieldCode: 'code'}, $event)"
                  :disabled="getFieldDisabledByCode('code')" 
                  clearable
                  class="compact-input">
                </el-input>
              </el-form-item>
            </el-col>
            <!-- 单位剂量 col=6 -->
            <el-col :span="6" v-if="showRequiredField('unitDose')">
              <el-form-item 
                label="单位剂量：" 
                prop="unitDose"
                :rules="getFieldRequiredRules('unitDose')"
                class="form-item-compact form-item-adaptive">
                <el-input 
                  v-model="form.unitDose"
                  placeholder="请输入单位剂量"
                  @blur="handleFieldBlur({fieldCode: 'unitDose'})"
                  @input="handleFieldInput({fieldCode: 'unitDose'}, $event)"
                  :disabled="getFieldDisabledByCode('unitDose')" 
                  clearable
                  class="compact-input">
                </el-input>
              </el-form-item>
            </el-col>
            
            <!-- 剂量单位 col=6 -->
            <el-col :span="6" v-if="showRequiredField('dosUnt')">
              <el-form-item 
                label="剂量单位：" 
                prop="dosUnt"
                :rules="getFieldRequiredRules('dosUnt')"
                class="form-item-compact form-item-adaptive">
                <!-- 剂量单位下拉框 -->
                <el-select 
                  v-model="form.dosUnt"
                  placeholder="请选择剂量单位"
                  @change="handleFieldChange({fieldCode: 'dosUnt'}, $event)"
                  :disabled="getFieldDisabledByCode('dosUnt')"
                  filterable
                  clearable
                  class="compact-select dos-unt-select"
                  popper-class="custom-unit-dropdown">
                  <el-option
                    v-for="option in dosUnt"
                    :key="option.id"
                    :label="option.label"
                    :value="option.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            
            <!-- 最小剂量 col=6 -->
            <el-col :span="6" v-if="showRequiredField('minDose')">
              <el-form-item 
                label="最小剂量：" 
                prop="minDose"
                :rules="getFieldRequiredRules('minDose')"
                class="form-item-compact form-item-adaptive">
                <el-input 
                  v-model="form.minDose"
                  placeholder="请输入最小剂量"
                  @blur="handleFieldBlur({fieldCode: 'minDose'})"
                  @input="handleFieldInput({fieldCode: 'minDose'}, $event)"
                  :disabled="getFieldDisabledByCode('minDose')" 
                  clearable
                  class="compact-input">
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          
          <!-- 第三行：新增行 - 动态布局 -->
          <el-row :gutter="8" class="required-fields-row third-required-row">
            <!-- 包装规格 col=6 -->
            <el-col :span="6" v-if="showRequiredField('pacSpec')">
              <el-form-item 
                label="包装规格：" 
                prop="pacSpec"
                :rules="getFieldRequiredRules('pacSpec')"
                class="form-item-compact form-item-adaptive">
                <el-input 
                  v-model="form.pacSpec"
                  placeholder="请输入包装规格"
                  @blur="handleFieldBlur({fieldCode: 'pacSpec'})"
                  @input="handleFieldInput({fieldCode: 'pacSpec'}, $event)"
                  :disabled="getFieldDisabledByCode('pacSpec')" 
                  clearable
                  class="compact-input">
                </el-input>
              </el-form-item>
            </el-col>
            
            <!-- 零售单位 col=6 -->
            <el-col :span="getThirdRowColSpan()" v-if="showRequiredField('saleUnt')">
              <el-form-item 
                label="零售单位：" 
                prop="saleUnt"
                :rules="getFieldRequiredRules('saleUnt')"
                class="form-item-compact form-item-adaptive">
                <el-select 
                  v-model="form.saleUnt"
                  placeholder="请选择零售单位"
                  @change="handleFieldChange({fieldCode: 'saleUnt'}, $event)"
                  :disabled="getFieldDisabledByCode('saleUnt')"
                  filterable
                  clearable
                  class="compact-select">
                  <el-option
                    v-for="option in saleWaysOptions"
                    :key="option.id"
                    :label="option.label"
                    :value="option.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            
            <!-- 手工划价 col=6 -->
            <el-col :span="getThirdRowColSpan()" v-if="showRequiredField('manualPric')">
              <el-form-item 
                label="手工划价：" 
                prop="manualPric"
                :rules="getFieldRequiredRules('manualPric')"
                class="form-item-compact form-item-adaptive">
                <el-select 
                  v-model="form.manualPric"
                  placeholder="请选择手工划价"
                  @change="handleFieldChange({fieldCode: 'manualPric'}, $event)"
                  :disabled="getFieldDisabledByCode('manualPric')"
                  clearable
                  class="compact-select">
                  <el-option
                    v-for="option in YNoptions"
                    :key="option.id"
                    :label="option.label"
                    :value="option.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            
            <!-- 指定售价 col=6 -->
            <el-col :span="getThirdRowColSpan()" v-if="showRequiredField('isFixPrice')">
              <el-form-item 
                label="指定售价：" 
                prop="isFixPrice"
                :rules="getFieldRequiredRules('isFixPrice')"
                class="form-item-compact form-item-adaptive">
                <el-select 
                  v-model="form.isFixPrice"
                  placeholder="请选择指定售价"
                  @change="handleIsFixPriceChange($event)"
                  :disabled="getFieldDisabledByCode('isFixPrice')"
                  clearable
                  class="compact-select">
                  <el-option
                    v-for="option in YNoptions"
                    :key="option.id"
                    :label="option.label"
                    :value="option.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            
            <!-- 当指定售价为1时显示的字段 -->
            <template v-if="form.isFixPrice == 1">
              <!-- 包装指定售价 col=6 -->
              <el-col :span="getThirdRowColSpan()" v-if="showRequiredField('fixPacSalePric')">
                <el-form-item 
                  label="包装指定售价：" 
                  prop="fixPacSalePric"
                  :rules="getFixPriceValidationRules('fixPacSalePric')"
                  class="form-item-compact form-item-adaptive amount-field">
                  <el-input 
                    v-model="form.fixPacSalePric"
                    placeholder="请输入包装指定售价"
                    @blur="handleFixPriceBlur('fixPacSalePric')"
                    @input="handleFixPriceInput('fixPacSalePric', $event)"
                    :disabled="getFieldDisabledByCode('fixPacSalePric')" 
                    clearable
                    class="compact-input amount-input">
                    <template slot="suffix">
                      <span class="amount-suffix">￥</span>
                    </template>
                  </el-input>
                </el-form-item>
              </el-col>
              
              <!-- 最小指定售价 col=6 -->
              <el-col :span="getThirdRowColSpan()" v-if="showRequiredField('fixMinSalePric')">
                <el-form-item 
                  label="最小指定售价：" 
                  prop="fixMinSalePric"
                  :rules="getFixPriceValidationRules('fixMinSalePric')"
                  class="form-item-compact form-item-adaptive amount-field">
                  <el-input 
                    v-model="form.fixMinSalePric"
                    placeholder="请输入最小指定售价"
                    @blur="handleFixPriceBlur('fixMinSalePric')"
                    @input="handleFixPriceInput('fixMinSalePric', $event)"
                    :disabled="getFieldDisabledByCode('fixMinSalePric')" 
                    clearable
                    class="compact-input amount-input">
                    <template slot="suffix">
                      <span class="amount-suffix">￥</span>
                    </template>
                  </el-input>
                </el-form-item>
              </el-col>
            </template>
          </el-row>
          
          <!-- 第四行：原来的第三行 - 加成方式、取整方式等 -->
          <el-row :gutter="8" class="required-fields-row fourth-required-row">
            <!-- 加成方式序号 col=12 -->
            <el-col :span="12" v-if="showRequiredField('markUpId')">
              <el-form-item 
                label="加成方式：" 
                prop="markUpId"
                :rules="getFieldRequiredRules('markUpId')"
                class="form-item-compact form-item-adaptive">
                <el-select 
                  v-model="form.markUpId"
                  placeholder="请选择加成方式"
                  @change="handleMarkUpChange($event)"
                  :disabled="getFieldDisabledByCode('markUpId')"
                  filterable
                  clearable
                  class="compact-select">
                  <el-option
                    v-for="option in markUpOption"
                    :key="option.id"
                    :label="option.label"
                    :value="option.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            
            <!-- 加成比例/加成金额 col=6 -->
            <el-col :span="6" v-if="showFourthRowMarkUpField()">
              <!-- 根据加成方式显示加成比例或加成金额 -->
              <el-form-item 
                v-if="form.markUpId != 2"
                :label="form.markUpId == 3 ? '手工比例：' : '加成比例：'" 
                prop="markUpRate"
                :rules="getMarkUpRateValidationRules()"
                class="form-item-compact form-item-adaptive">
                <el-input 
                  v-model="form.markUpRate"
                  :placeholder="form.markUpId == 3 ? '请输入加成比例百分比' : '请输入加成比例'"
                  @blur="handleMarkUpRateBlur()"
                  @input="handleFieldInput({fieldCode: 'markUpRate'}, $event)"
                  :disabled="getFieldDisabledByCode('markUpRate')" 
                  clearable
                  class="compact-input">
                </el-input>
              </el-form-item>
              
              <el-form-item 
                v-else-if="form.markUpId == 2"
                label="加成金额：" 
                prop="markUpPric"
                :rules="getMarkUpPricValidationRules()"
                class="form-item-compact form-item-adaptive">
                <el-input 
                  v-model="form.markUpPric"
                  placeholder="请输入加成金额"
                  @blur="handleMarkUpPricBlur()"
                  @input="handleFieldInput({fieldCode: 'markUpPric'}, $event)"
                  :disabled="getFieldDisabledByCode('markUpPric')" 
                  clearable
                  class="compact-input">
                </el-input>
              </el-form-item>
            </el-col>
            
            <!-- 取整方式 col=6 -->
            <el-col :span="6" v-if="showRequiredField('roundUnt')">
              <el-form-item 
                label="取整方式：" 
                prop="roundUnt"
                :rules="getFieldRequiredRules('roundUnt')"
                class="form-item-compact form-item-adaptive">
                <el-select 
                  v-model="form.roundUnt"
                  placeholder="请选择取整方式"
                  @change="handleFieldChange({fieldCode: 'roundUnt'}, $event)"
                  :disabled="getFieldDisabledByCode('roundUnt')"
                  filterable
                  clearable
                  class="compact-select">
                  <el-option
                    v-for="option in roundUntoptions"
                    :key="option.id"
                    :label="option.label"
                    :value="option.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          
          <!-- 非必填字段区域 -->
          <div class="optional-fields-section" v-if="optionalFields.length > 0">
            <el-row :gutter="8" class="dynamic-fields-grid">
              <!-- 其他非必填字段 -->
              <template v-for="field in optionalFields">
                <!-- 排除已在必填区域显示的字段 -->
                <el-col 
                  v-if="!isRequiredField(field.fieldCode)"
                  :key="field.fieldCode" 
                  :span="6"
                  class="field-col">
                  <!-- 非必填字段渲染逻辑保持不变 -->
                  <el-form-item 
                    :label="field.fieldName + '：'" 
                    :prop="field.fieldCode"
                    :rules="getFieldRules(field)" 
                    class="form-item-compact form-item-adaptive">
                    
                    <!-- 输入框类型字段 -->
                    <el-input 
                      v-if="field.inputBoxType === 'input'" 
                      v-model="form[field.fieldCode]"
                      :placeholder="getFieldPlaceholder(field)"
                      @blur="handleFieldBlur(field)"
                      @input="handleFieldInput(field, $event)"
                      :disabled="getFieldDisabled(field)" 
                      clearable
                      class="compact-input"
                      :class="getNumberFieldClass(field)">
                    </el-input>
                    
                    <!-- 下拉选择框类型 -->
                    <el-select 
                      v-else-if="field.inputBoxType === 'selected'"
                      v-model="form[field.fieldCode]"
                      :placeholder="getFieldPlaceholder(field)"
                      @change="handleFieldChange(field, $event)"
                      :disabled="getFieldDisabled(field)"
                      filterable
                      clearable
                      class="compact-select">
                      <el-option
                        v-for="option in getFieldOptions(field)"
                        :key="option.id"
                        :label="option.label"
                        :value="option.id"></el-option>
                    </el-select>
                    
                    <!-- 其他字段类型保持不变 -->
                    <el-input-number
                      v-else-if="field.inputBoxType === 'inputNumber'"
                      v-model="form[field.fieldCode]" 
                      :controls="false" 
                      :min="getNumberMin(field)"
                      :max="getNumberMax(field)" 
                      :step="getNumberStep(field)"
                      :precision="getNumberPrecision(field)" 
                      :placeholder="getFieldPlaceholder(field)"
                      @blur="handleFieldBlur(field)" 
                      @change="handleFieldChange(field, $event)"
                      :disabled="getFieldDisabled(field)" 
                      class="compact-input-number"
                      :class="getNumberFieldClass(field)"
                    ></el-input-number>
                    
                    <!-- 复选框 -->
                    <template v-else-if="field.inputBoxType === 'checked'">
                      <el-checkbox v-for="option in getFieldOptions(field)" :key="option.value"
                        :label="option.value" v-model="form[field.fieldCode]"
                        @change="handleFieldChange(field)" class="compact-checkbox">
                        {{ option.label }}
                      </el-checkbox>
                    </template>
                    <!-- 在F2子组件的模板中添加 -->
                    <template v-else-if="field.inputBoxType === 'switch'">
                      <!-- 将switch改为select -->
                      <el-select 
                        v-model="form[field.fieldCode]"
                        :placeholder="getFieldPlaceholder(field)"
                        @change="handleFieldChange(field, $event)"
                        :disabled="getFieldDisabled(field)"
                        filterable
                        clearable
                        class="compact-select"
                        style="width: 100%;">
                        <el-option
                          v-for="option in statusOptions"
                          :key="option.id"
                          :label="option.label"
                          :value="option.id">
                        </el-option>
                      </el-select>
                    </template>
                    <!-- 级联选择框 -->
                    <el-cascader v-else-if="field.inputBoxType === 'cascader'" v-model="form[field.fieldCode]"
                      :options="getCascaderOptions(field)" :props="getCascaderProps(field)"
                      :placeholder="getFieldPlaceholder(field)" @change="handleFieldChange(field)" clearable
                      filterable class="compact-cascader"></el-cascader>
                    
                    <!-- 日期选择器 -->
                    <el-date-picker v-else-if="field.inputBoxType === 'dateTime'"
                      v-model="form[field.fieldCode]" :type="getDatePickerType(field)"
                      :placeholder="getFieldPlaceholder(field)" @change="handleFieldChange(field)"
                      class="compact-datepicker" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
                    
                    <!-- 默认输入框 -->
                    <el-input v-else v-model="form[field.fieldCode]" :placeholder="getFieldPlaceholder(field)"
                      @blur="updateForm" @input="handleFieldInput(field)" clearable
                      class="compact-input"></el-input>
                  </el-form-item>
                </el-col>
              </template>
            </el-row>
          </div>
          
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import { pinyin } from 'pinyin-pro';
import {
  getDrugUnt,
  getDosaUnt,
  getMedicationFrequency,
  getMedicationWay,
  getMedcas,
} from "@/api/MedicenCata.js";
import { docMarkById } from "@/api/MedicenCata.js";

export default {
  name: 'BasicInfo',
  props: {
    form: {
      type: Object,
      required: true,
    },
    formDisabled: {
      type: Boolean,
      default: false
    },
    mode: {
      type: String,
      default: 'add'
    },
    disablePackingQuantity: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isSameUnit() {
      return this.form.pacUnt && this.form.minUnt && this.form.pacUnt === this.form.minUnt;
    },
    
    // 当前加成方式名称
    currentMarkUpName() {
      const selectedOption = this.markUpOption.find(option => option.id === this.form.markUpId);
      return selectedOption ? selectedOption.label : '';
    },
    
    // 获取非必填字段
    optionalFields() {
          if (!this.dynamicFields || this.dynamicFields.length === 0) {
            return [];
          }
          
          return this.dynamicFields.filter(field => {
            // 过滤出非必填字段
            if (!field.isShow) return false;
            
            // 检查是否是前4行必填字段中的字段
            const requiredFieldCodes = [
              'drugName', 'code', 'pacCnt', 'pacSpec',
              'pacUnt', 'unitDose', 'dosUnt', 'minDose',
              'minUnt', 'saleUnt', 'manualPric', 'isFixPrice',  // 新增的四个字段
              'markUpId', 'markUpRate', 'markUpPric', 'roundUnt'
            ];
            
            // 如果是前4行的字段，不显示在非必填区域
            if (requiredFieldCodes.includes(field.fieldCode)) {
              return false;
            }
            
            // 返回真正的非必填字段
            return true;
          });
	},
  },
  watch: {
    dynamicFields: {
        deep: true,
        immediate: true,
        handler(newVal, oldVal) {
          console.log('dynamicFields变化:', newVal.length, '个字段');
          
          // 检查state和isBar字段类型
          if (newVal && newVal.length > 0) {
            const stateField = newVal.find(f => f.fieldCode === 'state');
            const isBarField = newVal.find(f => f.fieldCode === 'isBar');
            
            if (stateField) {
              console.log('state字段类型:', stateField.inputBoxType, '是否正确:', stateField.inputBoxType === 'selected');
            }
            
            if (isBarField) {
              console.log('isBar字段类型:', isBarField.inputBoxType, '是否正确:', isBarField.inputBoxType === 'selected');
            }
            
            // 如果字段类型不正确，强制修正
            if (stateField && stateField.inputBoxType !== 'selected') {
              console.log('state字段类型不正确，强制修正');
              stateField.inputBoxType = 'selected';
              this.$nextTick(() => {
                this.forceRerender();
              });
            }
            
            if (isBarField && isBarField.inputBoxType !== 'selected') {
              console.log('isBar字段类型不正确，强制修正');
              isBarField.inputBoxType = 'selected';
              this.$nextTick(() => {
                this.forceRerender();
              });
            }
          }
          
          this.$nextTick(() => {
            this.rebuildFieldMaps();
          });
        }
      },
    
    'form.kcId': {
      immediate: true,
      handler(newVal) {
        this.setPacCntDisabledState(Number(newVal));
      }
    },
    
    'disablePackingQuantity': {
      immediate: true,
      handler(newVal) {
        this.$forceUpdate();
      }
    },
    
    'form.markUpId': {
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.$nextTick(() => {
            this.forceReRenderFields();
          });
        }
      },
      immediate: true
    },
    
    'form.costPric': {
      handler(newVal) {
        if (this.form.markUpId === 1 && newVal) {
          this.calculateMarkUpRateFromApi();
        }
      }
    },
    
    'form.antc': {
      immediate: true,
      handler(newVal) {
        if (newVal === 1) {
          this.setMedicalRecordFeeForAntibiotic();
        }
      }
    },
    
    'form': {
      deep: true,
      immediate: true,
      handler(newForm) {
        if (this.mode === 'add' && (!newForm.markUpId || newForm.markUpId === '')) {
          this.form.markUpId = 1;
          this.$nextTick(() => {
            this.handleMarkUpIdChange(1);
          });
        }
        
        if (this.mode === 'edit' && (newForm.phamType1 || newForm.phamType2 || newForm.phamType3)) {
          this.$nextTick(() => {
            this.initPhamTypeValue();
          });
        }
        
        if (newForm.markUpId === undefined || newForm.markUpId === null || newForm.markUpId === '') {
          this.form.markUpId = 1;
        }
      }
    },
    
    'form.drugType': {
      immediate: true,
      handler(newVal) {
        if (newVal === 1) {
          this.setMedicalRecordFeeForWesternMedicine();
        }
      }
    }
  },
  data() {
    return {
      dynamicFields: [],
      fieldOptionsMap: new Map(),
      fieldRulesMap: new Map(),
      fieldTypeValidators: new Map(),
      specialFields: ['unitDose', 'phamType', 'dosUnt', 'pacUnt', 'minUnt'],
      fieldConfigProcessed: false,
      pendingFieldConfig: null,
      fieldRenderKey: 0,
      fieldCodeOptionsMap: new Map(),
      
      antcLvOption: [
        { id: 1, label: '一级抗生素' },
        { id: 2, label: '二级抗生素' },
        { id: 3, label: '三级抗生素' }
      ],
      
      unitDoseOptions: [],
      dosUnt: [],
      getMinUntOptions: [],
      methodTypeOptions: [],
      unitChangeInProgress: false,
      drugCategoryOption: [],
      drugCategoryChildOption: [],
      threeLevelDrugCategoryOption: [],
      usedFrquIdOptions: [],
      
      expensiveTypeOptions: [
        { id: 1, label: '普价' },
        { id: 2, label: '贵重' },
        { id: 3, label: '昂贵' },
        { id: 4, label: '免费' }
      ],
      
      roundUntoptions: [
        { id: 1, label: '单次取整' },
        { id: 2, label: '总量取整' },
        { id: 3, label: '处方取整' }
      ],
      
      poisonousTypeOption: [],
      nurtureType: [
        { id: 1, label: '常规养护', value: '常规养护' },
        { id: 2, label: '重点养护', value: '重点养护' }
      ],
      
      lmtSpc: [
        { id: 0, label: '全院' },
        { id: 1, label: '门诊' }
      ],
      
      YNoptions: [
        { id: 0, label: '否', value: '否' },
        { id: 1, label: '是', value: '是' }
      ],
      
      statusOptions: [
        { id: 0, label: '禁用' },
        { id: 1, label: '可用' }
      ],
      
      saleWaysOptions: [
        { id: 1, label: '最小单位' },
        { id: 2, label: '包装单位' }
      ],
      
      markUpOption: [
        { id: 1, label: '比例加成' },
        { id: 2, label: '固定加成' },
        { id: 3, label: '手工比例加成' },
        { id: 4, label: '不加成' }
      ],
      
      medcWayIdOptions: [],
      medicalRecordFeeOption: [],
      
      markUpNameMap: {
        1: '比例加成',
        2: '固定加成',
        3: '手工比例加成',
        4: '不加成'
      },
      
      phamTypeValue: [],
      phamTypeOptions: [],
      cascaderProps: {
        value: 'id',
        label: 'label',
        children: 'children',
        lazy: true,
        lazyLoad: this.loadPhamTypeChildren,
        checkStrictly: true,
        emitPath: true
      },
      
      loadingPhamTypes: false,
      phamTypeCache: new Map(),
      searchText: '',
      filteredUnitOptions: [],
      allUnitOptions: [],
      addRules: {},
    }
  },
  
  mounted() {
    console.log('F2组件mounted');
    
    this.$nextTick(async () => {
      try {
        await Promise.all([
          this.pacUnt(),
          this.loadUnitOptions(),
          this.getDosaUnts(),
          this.getMedicationFrequency(),
          this.getMedicationWay(),
          this.getMedcas()
        ]);
        
        this.initForm();
        
        // 检查是否有等待的字段配置
        if (this.pendingFieldConfig) {
          console.log('mounted中有等待的字段配置，开始处理');
          this.processPendingFieldConfig();
        } else {
          console.log('mounted中设置默认字段');
          this.setupDefaultFields();
        }
        
        // 确保状态字段有值
        if (this.form.state === undefined || this.form.state === null || this.form.state === '') {
          this.form.state = '1';
        }
        
        // 确保是否启用追溯码字段有值
        if (this.form.isBar === undefined || this.form.isBar === null || this.form.isBar === '') {
          this.form.isBar = 1; // 默认为启用
        }
        
        if (this.form.markUpId) {
          this.setMarkUpNameByMarkUpId(this.form.markUpId);
        }
        
        // 初始化完成后强制刷新一次
        setTimeout(() => {
          this.forceRerender();
          console.log('组件初始化完成，已强制刷新');
        }, 200);
        
      } catch (error) {
        console.error('组件初始化失败:', error);
        this.$message.error('组件初始化失败');
      }
    });
  },
  
  methods: {
    // 判断是否显示必填字段
    showRequiredField(fieldCode) {
      const field = this.dynamicFields.find(f => f.fieldCode === fieldCode);
      if (!field) return false;
      
      // 检查是否是必填字段
      return field.isMustFill === 1 || field.isMustChoose === 1;
    },
    
	// 提供给父组件调用的刷新方法
	refreshComponent() {
	  console.log('父组件调用刷新方法');
	  this.forceRerender();
	  
	  // 同时重新处理字段配置
	  if (this.dynamicFields.length > 0) {
	    this.$nextTick(() => {
	      this.rebuildFieldMaps();
	      console.log('组件刷新完成');
	    });
	  }
	},
	
	// 提供给父组件调用，重新加载字段配置
	reloadFieldConfig(fieldConfig) {
	  console.log('重新加载字段配置');
	  this.setFieldConfig(fieldConfig);
	},
	
	// 在mounted或初始化方法中设置最小单位选项
	async loadUnitOptions() {
	  try {
	    // 加载包装单位
	    const pacUntRes = await getDrugUnt();
	    if (pacUntRes.code === 200) {
	      this.allUnitOptions = pacUntRes.data.map(v => ({
	        label: v.name,
	        ...v
	      }));
	      this.filteredUnitOptions = [...this.allUnitOptions];
	      
	      // 将最小单位选项设置为与包装单位相同
	      this.getMinUntOptions = [...this.allUnitOptions];
	    }
	    
	    // 加载剂量单位
	    const dosUntRes = await getDosaUnt();
	    if (dosUntRes.code === 200) {
	      this.dosUnt = dosUntRes.data.map(v => ({
	        label: v.name,
	        ...v
	      }));
	    }
	  } catch (error) {
	    console.error('加载单位选项失败:', error);
	  }
	},
	
    // 判断是否显示第三行的加成字段
    showThirdRowMarkUpField() {
      const markUpId = this.parseMarkUpId(this.form.markUpId);
      console.log('showThirdRowMarkUpField - 当前markUpId:', markUpId, '类型:', typeof markUpId);
      
      if (markUpId === 2) {
        // 固定加成模式：检查markUpPric字段
        const field = this.dynamicFields.find(f => f.fieldCode === 'markUpPric');
        console.log('固定加成模式 - 查找markUpPric字段:', field);
        
        if (field && field.isShow === 1) {
          console.log('固定加成模式 - 显示加成金额字段');
          return true;
        }
        
        // 即使字段配置中isShow不为1，在固定加成模式下也应该显示
        console.log('固定加成模式 - 强制显示加成金额字段');
        return true;
      } else if (markUpId === 1 || markUpId === 3) {
        // 比例加成或手工比例加成模式：检查markUpRate字段
        const field = this.dynamicFields.find(f => f.fieldCode === 'markUpRate');
        console.log('比例加成/手工加成模式 - 查找markUpRate字段:', field);
        
        if (field && field.isShow === 1) {
          console.log('比例加成/手工加成模式 - 显示加成比例字段');
          return true;
        }
        
        // 即使字段配置中isShow不为1，在比例加成模式下也应该显示
        console.log('比例加成/手工加成模式 - 强制显示加成比例字段');
        return true;
      }
      
      console.log('其他模式 - 不显示');
      return false;
    },
    
    // 判断是否应该显示加成金额字段
    shouldShowMarkUpPricField() {
      const field = this.dynamicFields.find(f => f.fieldCode === 'markUpPric');
      if (!field) return false;
      
      // 如果是固定加成模式，应该显示加成金额字段
      const markUpId = this.parseMarkUpId(this.form.markUpId);
      if (markUpId === 2) {
        return field.isShow === 1;
      }
      
      return false;
    },
    
    // 判断是否应该显示加成比例字段
    shouldShowMarkUpRateField() {
      const field = this.dynamicFields.find(f => f.fieldCode === 'markUpRate');
      if (!field) return false;
      
      // 如果是比例加成或手工比例加成模式，应该显示加成比例字段
      const markUpId = this.parseMarkUpId(this.form.markUpId);
      if (markUpId === 1 || markUpId === 3) {
        return field.isShow === 1;
      }
      
      return false;
    },
    
    // 获取字段必填规则
    getFieldRequiredRules(fieldCode) {
      const field = this.dynamicFields.find(f => f.fieldCode === fieldCode);
      if (!field) return [];
      
      const rules = [];
      
      if (field.isMustFill === 1 && field.inputBoxType === 'input') {
        rules.push({
          required: true,
          message: `请输入${field.fieldName}`,
          trigger: 'blur'
        });
      }
      
      if (field.isMustChoose === 1 && field.inputBoxType === 'selected') {
        rules.push({
          required: true,
          message: `请选择${field.fieldName}`,
          trigger: 'change'
        });
      }
      
      return rules;
    },
    
    // 根据字段编码获取字段禁用状态
    getFieldDisabledByCode(fieldCode) {
      const field = this.dynamicFields.find(f => f.fieldCode === fieldCode);
      if (!field) return false;
      
      return this.getFieldDisabled(field);
    },
    
    // 处理字段输入
    handleFieldInput(field, value) {
      const validatedValue = this.validateNumberInput(field, value);
      
      if (validatedValue !== value) {
        this.form[field.fieldCode] = validatedValue;
        this.$nextTick(() => {
          this.$forceUpdate();
        });
      }
      
      // 特殊字段处理
      if (field.fieldCode === 'alis') {
        this.handleAliasInput(this.form.alis);
      }
      
      if (field.fieldCode === 'costPric') {
        this.handleCostPriceChange(this.form.costPric);
      }
      
      if (field.fieldCode === 'markUpRate') {
        const markUpId = this.parseMarkUpId(this.form.markUpId);
        if (markUpId === 1 || markUpId === 3) {
          // 比例加成或手工加成模式
          this.handleMarkUpRateInput(field, value);
        }
      }
      
      if (field.fieldCode === 'markUpPric') {
        const markUpId = this.parseMarkUpId(this.form.markUpId);
        if (markUpId === 2) {
          // 固定加成模式
          this.handleMarkUpPricInput(field, value);
        }
      }
      
      this.updateForm();
    },
    
    // 处理加成金额输入
    handleMarkUpPricInput(field, value) {
      const markUpId = this.parseMarkUpId(this.form.markUpId);
      let validatedValue = value;
      
      // 只允许数字和小数点
      validatedValue = validatedValue.replace(/[^\d.]/g, '');
      
      // 确保只有一个小数点
      const parts = validatedValue.split('.');
      if (parts.length > 2) {
        validatedValue = parts[0] + '.' + parts.slice(1).join('');
      }
      
      // 确保是正数
      if (validatedValue) {
        const numValue = parseFloat(validatedValue);
        if (!isNaN(numValue) && numValue < 0) {
          validatedValue = Math.abs(numValue).toString();
        }
      }
      
      this.form[field.fieldCode] = validatedValue;
      
      // 实时计算销售价格
      if (this.form.costPric && validatedValue) {
        this.calculateSalePrice();
      }
      
      this.updateForm();
    },
    
    // 处理药品别名输入
    handleAliasInput(value) {
      this.form.alisPyCode = this.getFirstLetter(value);
      this.updateForm();
    },
    
    // 处理成本单价变化
    handleCostPriceChange(value) {
      if (value !== '' && !isNaN(value) && parseFloat(value) >= 0) {
        this.form.costPric = value;
        
        if (this.form.markUpId === 1) {
          this.$nextTick(() => {
            this.calculateMarkUpRateFromApi();
          });
        }
        
        this.calculateSalePrice();
        
        if (this.form.markUpId === 4) {
          this.$nextTick(() => {
            this.calculateSalePriceForNoMarkUp();
          });
        }
      } else {
        this.form.costPric = '';
      }
    },
    
    // 判断是否为单位字段
    isUnitField(fieldCode) {
      return ['dosUnt', 'pacUnt', 'minUnt'].includes(fieldCode);
    },
    
    // 获取过滤后的单位选项
    getFilteredUnitOptions(field) {
      if (field.fieldCode === 'dosUnt') {
        return this.dosUnt || [];
      }
      return this.filteredUnitOptions;
    },
    
    // 单位字段变化处理
    handleUnitFieldChange(field) {
      if (field.fieldCode === 'pacUnt') {
        this.handlePacUntChange(this.form.pacUnt);
      } else if (field.fieldCode === 'minUnt') {
        this.handleMinUntChange(this.form.minUnt);
      } else if (field.fieldCode === 'dosUnt') {
        this.handleDosUntChange(this.form.dosUnt);
      }
      this.updateForm();
    },
    
    // 单位过滤方法
    filterPacUnit(query) {
      this.searchText = query;
      if (query) {
        this.filteredUnitOptions = this.allUnitOptions.filter(item => {
          return item.label.toLowerCase().includes(query.toLowerCase()) ||
            this.getPinyin(item.label).toLowerCase().includes(query.toLowerCase());
        });
      } else {
        this.filteredUnitOptions = [...this.allUnitOptions];
      }
    },
    
    // 获取拼音
    getPinyin(text) {
      try {
        return pinyin(text, {
          toneType: 'none',
          type: 'array'
        }).join('');
      } catch (error) {
        return text;
      }
    },
    
    // 高亮文本
    highlightText(text, searchText) {
      if (!searchText) return text;
      const regex = new RegExp(`(${this.escapeRegExp(searchText)})`, 'gi');
      return text.replace(regex, '<span class="highlight-text">$1</span>');
    },
    
    // 转义正则表达式
    escapeRegExp(string) {
      return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    },
    
    // 判断固定加成是否应该禁用
    shouldDisableMarkUpFixed() {
      const markUpId = this.parseMarkUpId(this.form.markUpId);
      return markUpId !== 4;
    },
    
    // 获取字段禁用状态
    getFieldDisabled(field) {
      let disabled = this.formDisabled || this.mode === 'view';
      
      if (field.fieldCode === 'pacCnt') {
        disabled = disabled || this.disablePackingQuantity;
      }
      
      if (field.fieldCode === 'markUpFixed') {
        disabled = true;
      }
      
      if (field.fieldCode === 'markUpPric') {
        const markUpId = this.parseMarkUpId(this.form.markUpId);
        disabled = disabled || markUpId !== 2;
      }
      
      if (field.fieldCode === 'markUpRate') {
        const markUpId = this.parseMarkUpId(this.form.markUpId);
        disabled = disabled || markUpId === 2;
      }
      
      return disabled;
    },
    
    // 设置包装数量禁用状态
    setPacCntDisabledState(kcId) {
      const shouldDisable = kcId === 1;
      if (this.disablePackingQuantity !== shouldDisable) {
        this.disablePackingQuantity = shouldDisable;
      }
    },
    
    // 处理成本单价输入
    handleCostPriceInput(value) {
      this.handleFieldInput({fieldCode: 'costPric'}, value);
      
      // 如果是比例加成模式，当成本变化时直接计算销售价
      if (this.form.markUpId === 1 && this.form.costPric && this.form.markUpRate) {
        this.$nextTick(() => {
          this.calculateSalePriceDirectly();
        });
      }
    },
    
    // 处理加成方式变化
    async handleMarkUpChange(value) {
      const markUpId = this.parseMarkUpId(value);
      this.handleMarkUpIdChange(markUpId);
      
      switch (markUpId) {
        case 1:
          this.handleProportionalMarkUpWithReset();
          // 不再调用接口，直接计算销售价
          if (this.form.costPric && this.form.markUpRate) {
            this.calculateSalePriceDirectly();
          }
          break;
        case 2:
          this.handleFixedMarkUpWithReset();
          break;
        case 3:
          this.handleManualProportionalMarkUpWithValidation();
          break;
        case 4:
          this.handleNoMarkUpWithDefault();
          break;
      }
      
      this.forceUpdateValidationRules();
      this.updateForm();
    },
    
    // 解析加成方式ID
    parseMarkUpId(value) {
      if (value === undefined || value === null || value === '') {
        return 1;
      }
      const num = parseInt(value);
      return isNaN(num) ? 1 : num;
    },
    
    // 处理加成方式变化
    async handleMarkUpIdChange(markUpId) {
      try {
        this.updateMarkUpName();
        
        switch (markUpId) {
          case 1:
            await this.handleProportionalMarkUpWithCostCheck();
            break;
          case 2:
            this.handleFixedMarkUpWithReset();
            break;
          case 3:
            this.handleManualProportionalMarkUpWithValidation();
            break;
          case 4:
            this.handleNoMarkUpWithDefault();
            break;
        }
        
        this.rebuildValidationRules();
        this.clearFormValidation();
        this.updateForm();
      } catch (error) {
        this.$message.error('处理加成方式失败');
      }
    },
    
    // 处理比例加成
    async handleProportionalMarkUpWithCostCheck() {
      this.setMarkUpFieldState({
        markUpRate: true,
        markUpPric: true,
        markUpFixed: true
      });
      
      if (this.form.costPric && Number(this.form.costPric) > 0) {
        await this.calculateMarkUpRateFromApi();
      } else {
        this.form.markUpRate = '1';
      }
      
      this.form.markUpPric = '0';
      this.form.markUpFixed = 0;
      
      this.$nextTick(() => {
        this.calculateSalePrice();
      });
    },
    
    // 处理固定加成模式重置
    handleFixedMarkUpWithReset() {
      this.setMarkUpFieldState({
        markUpRate: true,
        markUpPric: false,
        markUpFixed: true
      });
      
      // 重置加成比例
      this.form.markUpRate = '1';
      
      // 设置固定加成标志
      this.form.markUpFixed = 1;
      
      // 如果没有加成金额，设置为0
      if (!this.form.markUpPric || this.form.markUpPric === '') {
        this.form.markUpPric = '0';
      }
      
      this.$nextTick(() => {
        this.calculateSalePrice();
      });
    },
    
    // 处理手工比例加成
    handleManualProportionalMarkUpWithValidation() {
      this.setMarkUpFieldState({
        markUpRate: false,
        markUpPric: true,
        markUpFixed: true
      });
      
      if (!this.form.markUpRate || this.form.markUpRate === '') {
        this.form.markUpRate = '1';
      }
      
      this.form.markUpPric = '';
      this.form.markUpFixed = 0;
      
      this.$nextTick(() => {
        this.validateMarkUpRateField();
        if (this.form.costPric && this.form.markUpRate) {
          this.calculateSalePriceForManualMarkUp();
        }
      });
    },
    
    // 处理不加成
    handleNoMarkUpWithDefault() {
      this.setMarkUpFieldState({
        markUpRate: true,
        markUpPric: true,
        markUpFixed: true
      });
      
      this.form.markUpRate = '1';
      this.form.markUpPric = '0';
      this.form.markUpFixed = 0;
      
      this.$nextTick(() => {
        this.calculateSalePriceForNoMarkUp();
      });
    },
    
    // 获取加成比例验证规则
    getMarkUpRateValidationRules() {
      const markUpId = this.parseMarkUpId(this.form.markUpId);
      const rules = [];
      
      if (markUpId === 1 || markUpId === 3) {
        rules.push({
          required: true,
          message: '请输入加成比例',
          trigger: 'blur'
        });
        
        if (markUpId === 1) {
          // 比例加成模式
          rules.push({
            validator: this.validateProportionalMarkUpRate,
            message: '加成比例必须是大于0的数字，最多3位小数',
            trigger: 'blur'
          });
        } else if (markUpId === 3) {
          // 手工加成模式
          rules.push({
            validator: this.validateManualMarkUpRate,
            message: '手工加成比例必须是大于1小于2的数字，最多3位小数',
            trigger: 'blur'
          });
        }
      }
      
      return rules;
    },
    
    // 修改从接口获取加成比例的方法 - 不再调用接口
    async calculateMarkUpRateFromApi() {
      // 根据需求，markUpId===1时不再调用接口
      // 直接使用输入的加成比例计算
      if (this.form.markUpId === 1) {
        this.calculateSalePriceDirectly();
      }
    },
    
    // 直接计算销售价格
    calculateSalePriceDirectly() {
      if (!this.form.costPric || !this.form.markUpRate) {
        return;
      }
      
      const cost = parseFloat(this.form.costPric);
      const rate = parseFloat(this.form.markUpRate);
      
      if (isNaN(cost) || isNaN(rate) || cost <= 0 || rate <= 0) {
        return;
      }
      
      // 比例加成模式：销售价 = 成本价 × 加成比例
      const salePrice = cost * rate;
      this.form.salePric = salePrice.toFixed(4);
      this.updateForm();
    },
    
    // 设置字段状态
    setMarkUpFieldState(state) {
      // 通过更新computed属性或操作DOM控制字段状态
    },
    
    // 手工比例加成输入处理
    handleMarkUpRateInputForManual(field) {
      this.form.markUpRate = this.form.markUpRate.replace(/\D/g, '');
      
      if (this.form.markUpRate === '') {
        this.form.markUpRate = '1';
      }
      
      this.$nextTick(() => {
        this.calculateSalePriceForManualMarkUp();
      });
      
      this.updateForm();
    },
    
    // 手工比例加成计算
    calculateSalePriceForManualMarkUp() {
      if (!this.form.costPric || !this.form.markUpRate) {
        return;
      }
      
      const cost = parseFloat(this.form.costPric);
      const rate = parseFloat(this.form.markUpRate);
      
      if (isNaN(cost) || isNaN(rate)) {
        return;
      }
      
      const salePrice = cost * (1 + rate / 100);
      this.form.salePric = salePrice.toFixed(4);
      this.updateForm();
    },
    
    // 验证加成比例字段
    validateMarkUpRateField() {
      if (this.$refs.form && this.form.markUpId === 3) {
        this.$refs.form.validateField('markUpRate', (errorMessage) => {
          if (errorMessage) {
            console.log('加成比例验证结果:', errorMessage);
          }
        });
      }
    },
    
    // 计算销售价格
    calculateSalePrice() {
      if (!this.form.costPric) {
        return;
      }
      
      const cost = parseFloat(this.form.costPric);
      if (isNaN(cost) || cost <= 0) {
        return;
      }
      
      const markUpId = this.parseMarkUpId(this.form.markUpId);
      
      switch (markUpId) {
        case 1:
          // 比例加成模式：销售价 = 成本价 × 加成比例
          if (this.form.markUpRate) {
            const rate = parseFloat(this.form.markUpRate);
            if (!isNaN(rate) && rate > 0) {
              this.form.salePric = (cost * rate).toFixed(4);
            }
          }
          break;
          
        case 2:
          // 固定加成模式：销售价 = 成本价 + 加成金额
          if (this.form.markUpPric) {
            const markup = parseFloat(this.form.markUpPric);
            if (!isNaN(markup) && markup >= 0) {
              this.form.salePric = (cost + markup).toFixed(4);
            }
          }
          break;
          
        case 3:
          // 手工比例加成模式：销售价 = 成本价 × 手工比例
          this.calculateManualProportionalMarkUp(cost);
          break;
          
        case 4:
          // 不加成模式
          this.calculateNoMarkUp(cost);
          break;
      }
      
      this.updateForm();
    },
	
    // 计算不加成
    calculateNoMarkUp(cost) {
      this.form.salePric = cost.toFixed(4);
      this.form.markUpPric = '0';
      this.form.markUpRate = '1';
      this.form.markUpFixed = 0;
    },
    
    // 计算不加成销售价格
    calculateSalePriceForNoMarkUp() {
      if (!this.form.costPric) {
        return;
      }
      
      const cost = parseFloat(this.form.costPric);
      if (isNaN(cost)) {
        return;
      }
      
      this.form.salePric = cost.toFixed(4);
      this.updateForm();
    },
    
    // 手工比例加成计算
    calculateManualProportionalMarkUp(cost) {
      if (!this.form.markUpRate) {
        this.form.salePric = '';
        return;
      }
      
      const rate = parseFloat(this.form.markUpRate);
      if (isNaN(rate)) {
        this.form.salePric = '';
        return;
      }
      
      if (rate <= 0) {
        this.form.salePric = '';
        return;
      }
      
      // 手工比例加成模式：销售价 = 成本价 × 手工比例
      const salePrice = cost * rate;
      this.form.salePric = salePrice.toFixed(4);
    },
    
    // 验证数字输入
    validateNumberInput(field, value) {
      const numberFields = [
        'unitDose', 'pacCnt', 'minDose', 'fixMinSalePric', 'fixPacSalePric',
        'costPric', 'salePric', 'markUpRate', 'markUpPric'
      ];
      
      if (!numberFields.includes(field.fieldCode)) {
        return value;
      }
      
      if (value === '' || value === null || value === undefined) {
        return value;
      }
      
      let strValue = String(value);
      strValue = strValue.replace(/[^\d.-]/g, '');
      
      const parts = strValue.split('.');
      if (parts.length > 2) {
        strValue = parts[0] + '.' + parts.slice(1).join('');
      }
      
      if (strValue.includes('-')) {
        const dashCount = (strValue.match(/-/g) || []).length;
        if (dashCount > 1) {
          strValue = '-' + strValue.replace(/-/g, '');
        } else if (!strValue.startsWith('-')) {
          strValue = '-' + strValue.replace(/-/g, '');
        }
      }
      
      if (strValue.startsWith('.')) {
        strValue = '0' + strValue;
      }
      
      if (strValue.startsWith('-.') && strValue.length > 2) {
        strValue = '-0' + strValue.substring(2);
      }
      
      return strValue;
    },
    
    // 处理字段变化
    handleFieldChange(field, value) {
      if (this.isNumberField(field.fieldCode)) {
        this.finalValidateNumberField(field, value);
      }
      
      if (field.fieldCode === 'markUpId') {
        this.handleMarkUpChange(this.form.markUpId);
      }
      
      if (field.fieldCode === 'pacUnt') {
        this.handlePacUntChange(this.form.pacUnt);
      }
      
      if (field.fieldCode === 'minUnt') {
        this.handleMinUntChange(this.form.minUnt);
      }
      
      this.updateForm();
    },
    
    // 判断是否为数字字段
    isNumberField(fieldCode) {
      const numberFields = [
        'unitDose', 'pacCnt', 'minDose', 'fixMinSalePric', 'fixPacSalePric',
        'costPric', 'salePric', 'markUpRate', 'markUpPric'
      ];
      return numberFields.includes(fieldCode);
    },
    
    // 最终校验数字字段
    finalValidateNumberField(field, value) {
      if (value === '' || value === null || value === undefined) {
        return;
      }
      
      const numValue = parseFloat(value);
      if (isNaN(numValue)) {
        this.$message.warning(`${field.fieldName}必须是有效的数字`);
        this.form[field.fieldCode] = '';
        return;
      }
      
      if (field.fieldCode === 'pacCnt') {
        if (!Number.isInteger(numValue) || numValue <= 0) {
          this.$message.warning('包装数量必须是大于0的正整数');
          this.form.pacCnt = 1;
          return;
        }
      }
      
      if (numValue < 0) {
        this.$message.warning(`${field.fieldName}不能为负数`);
        this.form[field.fieldCode] = Math.abs(numValue).toString();
      }
    },
    
    // 处理字段失去焦点
    handleFieldBlur(field) {
      switch (field.fieldCode) {
        case 'costPric':
          this.handleCostPriceBlur();
          break;
        case 'markUpRate':
          this.handleMarkUpRateBlur();
          break;
        case 'markUpPric':
          this.handleMarkUpPricBlur();
          break;
        case 'pacCnt':
          this.handlePacCntBlur();
          break;
        default:
          this.updateForm();
          break;
      }
    },
    
    // 成本单价失去焦点处理
    handleCostPriceBlur() {
      if (this.form.costPric && !isNaN(parseFloat(this.form.costPric))) {
        this.form.costPric = parseFloat(this.form.costPric).toFixed(4);
      }
      
      this.calculateSalePrice();
      this.updateForm();
    },
    
    // 判断是否显示指定字段
	showFieldByCode(fieldCode) {
	  const field = this.dynamicFields.find(f => f.fieldCode === fieldCode);
	  if (!field) return false;
	  
	  // 检查是否显示
	  return field.isShow === 1;
	},
	
	// 比例加成模式验证器 (markUpId === 1)
	validateProportionalMarkUpRate(rule, value, callback) {
	  if (!value && value !== 0) {
	    callback(new Error('请输入加成比例'));
	    return;
	  }
	  
	  const numValue = parseFloat(value);
	  if (isNaN(numValue)) {
	    callback(new Error('加成比例必须是数字'));
	    return;
	  }
	  
	  // 必须大于0
	  if (numValue <= 0) {
	    callback(new Error('加成比例必须大于0'));
	    return;
	  }
	  
	  // 检查小数位数
	  const decimalPlaces = (value.toString().split('.')[1] || '').length;
	  if (decimalPlaces > 3) {
	    callback(new Error('加成比例最多支持3位小数'));
	    return;
	  }
	  
	  callback();
	},
	
	// 手工加成模式验证器 (markUpId === 3)
	validateManualMarkUpRate(rule, value, callback) {
	  if (!value && value !== 0) {
	    callback(new Error('请输入手工加成比例'));
	    return;
	  }
	  
	  const numValue = parseFloat(value);
	  if (isNaN(numValue)) {
	    callback(new Error('手工加成比例必须是数字'));
	    return;
	  }
	  
	  // 必须大于1
	  if (numValue <= 1) {
	    callback(new Error('手工加成比例必须大于1'));
	    return;
	  }
	  
	  // 必须小于2
	  if (numValue >= 2) {
	    callback(new Error('手工加成比例必须小于2'));
	    return;
	  }
	  
	  // 检查小数位数
	  const decimalPlaces = (value.toString().split('.')[1] || '').length;
	  if (decimalPlaces > 3) {
	    callback(new Error('手工加成比例最多支持3位小数'));
	    return;
	  }
	  
	  callback();
	},
	
	// 获取加成金额验证规则
	getMarkUpPricValidationRules() {
	  const rules = [];
	  const markUpId = this.parseMarkUpId(this.form.markUpId);
	  
	  if (markUpId === 2) {
	    rules.push({
	      required: true,
	      message: '请输入加成金额',
	      trigger: 'blur'
	    });
	    
	    // 加成金额验证器 - 大于0的正数，最多三位小数
	    rules.push({
	      validator: this.validateMarkUpPric,
	      message: '加成金额必须是大于0的正数，最多三位小数',
	      trigger: 'blur'
	    });
	  }
	  
	  return rules;
	},
	
	// 加成金额验证器
	validateMarkUpPric(rule, value, callback) {
	  if (!value && value !== 0) {
	    callback(new Error('请输入加成金额'));
	    return;
	  }
	  
	  const numValue = parseFloat(value);
	  if (isNaN(numValue)) {
	    callback(new Error('加成金额必须是数字'));
	    return;
	  }
	  
	  // 必须大于0
	  if (numValue <= 0) {
	    callback(new Error('加成金额必须大于0'));
	    return;
	  }
	  
	  // 检查小数位数
	  const decimalPlaces = (value.toString().split('.')[1] || '').length;
	  if (decimalPlaces > 3) {
	    callback(new Error('加成金额最多支持3位小数'));
	    return;
	  }
	  
	  callback();
	},
	
	// 修改处理加成比例失去焦点的方法
	handleMarkUpRateBlur() {
	  const markUpId = this.parseMarkUpId(this.form.markUpId);
	  
	  if (markUpId === 3) {
		this.handleManualMarkUpRateBlur();
	  } else if (markUpId === 1) {
		this.handleProportionalMarkUpRateBlur();
	  } else {
		this.handleCommonMarkUpRateBlur();
	  }
	},
    
    // 手工比例加成模式下的加成比例失去焦点处理
    handleManualMarkUpRateBlur() {
      if (this.form.markUpRate) {
        const value = this.form.markUpRate.toString().trim();
        
        if (value === '') {
          this.form.markUpRate = '';
          this.$message.warning('手工加成比例不能为空');
          return;
        }
        
        const numValue = parseFloat(value);
        if (isNaN(numValue)) {
          this.form.markUpRate = '';
          this.$message.warning('手工加成比例必须是数字');
          return;
        }
        
        // 验证范围
        if (numValue <= 1) {
          this.form.markUpRate = '';
          this.$message.warning('手工加成比例必须大于1');
          return;
        }
        
        if (numValue >= 2) {
          this.form.markUpRate = '';
          this.$message.warning('手工加成比例必须小于2');
          return;
        }
        
        // 限制小数位数
        const decimalPlaces = (value.toString().split('.')[1] || '').length;
        if (decimalPlaces > 3) {
          this.form.markUpRate = parseFloat(numValue.toFixed(3));
          this.$message.warning('手工加成比例最多支持3位小数，已自动截断');
        } else {
          this.form.markUpRate = value;
        }
      }
      
      this.calculateSalePrice();
      this.updateForm();
    },
    
	// 修改手工加成输入处理
	handleManualMarkUpRateInput(field, value) {
	  // 只允许数字和小数点
	  const validatedValue = value.replace(/[^\d.]/g, '');
	  
	  // 确保只有一个小数点
	  const parts = validatedValue.split('.');
	  if (parts.length > 2) {
	    this.form[field.fieldCode] = parts[0] + '.' + parts.slice(1).join('');
	  } else {
	    this.form[field.fieldCode] = validatedValue;
	  }
	  
	  this.calculateSalePrice();
	  this.updateForm();
	},
	
	// 修改比例加成模式下的加成比例失去焦点处理
	handleProportionalMarkUpRateBlur() {
	  if (this.form.markUpRate) {
	    const value = this.form.markUpRate.toString().trim();
	    
	    if (value === '') {
	      this.form.markUpRate = '';
	      this.$message.warning('加成比例不能为空');
	      return;
	    }
	    
	    const numValue = parseFloat(value);
	    if (isNaN(numValue)) {
	      this.form.markUpRate = '';
	      this.$message.warning('加成比例必须是数字');
	      return;
	    }
	    
	    // 必须大于0
	    if (numValue <= 0) {
	      this.form.markUpRate = '';
	      this.$message.warning('加成比例必须大于0');
	      return;
	    }
	    
	    // 限制小数位数
	    const decimalPlaces = (value.toString().split('.')[1] || '').length;
	    if (decimalPlaces > 3) {
	      this.form.markUpRate = parseFloat(numValue.toFixed(3));
	      this.$message.warning('加成比例最多支持3位小数，已自动截断');
	    } else {
	      this.form.markUpRate = value;
	    }
	  }
	  
	  // 计算销售价格
	  this.calculateSalePrice();
	  this.updateForm();
	},
	
    // 通用加成比例失去焦点处理
    handleCommonMarkUpRateBlur() {
      if (this.form.markUpRate && !isNaN(parseFloat(this.form.markUpRate))) {
        const rate = parseFloat(this.form.markUpRate);
        if (rate > 0) {
          this.form.markUpRate = rate.toFixed(2);
        }
      }
      
      this.calculateSalePrice();
      this.updateForm();
    },
    
    // 加成金额失去焦点处理
    handleMarkUpPricBlur() {
      if (this.form.markUpPric) {
        const value = this.form.markUpPric.toString().trim();
        
        if (value === '') {
          this.form.markUpPric = '0';
          this.$message.warning('加成金额不能为空，已设置为0');
          return;
        }
        
        const numValue = parseFloat(value);
        if (isNaN(numValue)) {
          this.form.markUpPric = '0';
          this.$message.warning('加成金额必须是数字，已设置为0');
          return;
        }
        
        // 必须大于0
        if (numValue < 0) {
          this.form.markUpPric = '0';
          this.$message.warning('加成金额不能为负数，已设置为0');
          return;
        }
        
        if (numValue === 0) {
          this.form.markUpPric = '0';
        } else {
          // 限制小数位数
          const decimalPlaces = (value.toString().split('.')[1] || '').length;
          if (decimalPlaces > 3) {
            this.form.markUpPric = parseFloat(numValue.toFixed(3));
            this.$message.warning('加成金额最多支持3位小数，已自动截断');
          } else {
            this.form.markUpPric = value;
          }
        }
      } else {
        this.form.markUpPric = '0';
      }
      
      this.calculateSalePrice();
      this.updateForm();
    },
    
    // 包装数量失去焦点处理
    handlePacCntBlur() {
      if (this.form.pacUnt && this.form.minUnt && this.form.pacUnt === this.form.minUnt) {
        this.form.pacCnt = 1;
        this.$message.warning('包装单位和最小单位相同，包装数量必须为1');
      }
      
      this.updateForm();
    },
    
    // 包装单位
    async pacUnt() {
      let res = await getDrugUnt();
      if (res.code === 200) {
        this.allUnitOptions = res.data.map(v => ({
          label: v.name,
          ...v
        }));
        this.filteredUnitOptions = [...this.allUnitOptions];
      } else {
        this.$message.error(res.message);
      }
    },
    
    // 剂量单位
    async getDosaUnts() {
      let res = await getDosaUnt();
      if (res.code === 200) {
        this.dosUnt = res.data.map(v => ({
          label: v.name,
          ...v
        }));
        
        this.minUnt = res.data.map(v => ({
          label: v.name,
          ...v
        }));
      } else {
        this.$message.error(res.message);
      }
    },
    
    // 给药方式
    async getMedicationFrequency() {
      let res = await getMedicationFrequency();
      if (res.code === 200) {
        this.usedFrquIdOptions = res.data.map(v => ({
          label: v.name,
          ...v
        }));
      } else {
        this.$message.error(res.message);
      }
    },
    
    // 用药频率
    async getMedicationWay() {
      let res = await getMedicationWay();
      if (res.code === 200) {
        this.medcWayIdOptions = res.data.map(v => ({
          label: v.name,
          ...v
        }));
      } else {
        this.$message.error(res.message);
      }
    },
    
    // 病案费别
    async getMedcas() {
      try {
        const res = await getMedcas();
        if (res.code === 200) {
          this.medicalRecordFeeOption = res.data.map(v => ({
            label: v.name,
            id: v.id,
            ...v
          }));
          
          if (this.form.drugType === 1) {
            this.setMedicalRecordFeeForWesternMedicine();
          }
          
          if (this.form.antc === 1) {
            this.setMedicalRecordFeeForAntibiotic();
          }
        }
      } catch (error) {
        console.error('获取病案费别失败:', error);
      }
    },
    
    // 为西药设置病案费别
    setMedicalRecordFeeForWesternMedicine() {
      if (this.form.drugType === 1 && this.form.antc !== 1) {
        const westernMedicineOption = this.medicalRecordFeeOption.find(option =>
          option.label && option.label.includes('西药费')
        );
        
        if (westernMedicineOption) {
          this.form.mrsId = westernMedicineOption.id;
          this.updateForm();
        }
      }
    },
    
    // 为抗生素设置病案费别
    setMedicalRecordFeeForAntibiotic() {
      if (this.form.antc === 1) {
        const antibioticOption = this.medicalRecordFeeOption.find(option =>
          option.label && option.label.includes('抗生素费')
        );
        
        if (antibioticOption) {
          this.form.mrsId = antibioticOption.id;
          this.updateForm();
        }
      }
    },
    
    // 初始化表单
    initForm() {
      if (!this.form.markUpId) {
        this.form.markUpId = 1;
      }
      
      // 设置是否启用追溯码的默认值
      if (this.mode === 'add' && this.form.isBar === undefined) {
        this.form.isBar = 1; // 新增模式下默认启用追溯码
      }
      
      // 设置有效状态的默认值
      if (this.mode === 'add' && (this.form.state === undefined || this.form.state === null || this.form.state === '')) {
        this.form.state = 1; // 新增模式下默认为可用状态
      }
      
      this.updateMarkUpName();
    },
    
    // 更新加成方式名称
    updateMarkUpName() {
      this.form.markUpName = this.currentMarkUpName;
    },
    
    // 设置加成方式名称
    setMarkUpNameByMarkUpId(markUpId) {
      if (markUpId && this.markUpNameMap[markUpId]) {
        this.form.markUpName = this.markUpNameMap[markUpId];
      } else {
        this.form.markUpName = '';
      }
    },
    
    // 包装单位变化处理
    handlePacUntChange(value) {
      if (this.unitChangeInProgress) return;
      this.unitChangeInProgress = true;
      
      this.$nextTick(() => {
        this.checkUnitSame();
        this.unitChangeInProgress = false;
        this.updateForm();
      });
    },
    
    // 最小单位变化处理
    handleMinUntChange(value) {
      if (this.unitChangeInProgress) return;
      this.unitChangeInProgress = true;
      
      this.$nextTick(() => {
        this.checkUnitSame();
        this.unitChangeInProgress = false;
        this.updateForm();
      });
    },
    
    // 剂量单位变化处理
    handleDosUntChange(value) {
      this.updateForm();
    },
    
    // 检查单位是否相同
    checkUnitSame() {
      if (this.form.pacUnt && this.form.minUnt && this.form.pacUnt === this.form.minUnt) {
        this.form.pacCnt = 1;
        this.$message.info('包装单位和最小单位相同，包装数量已自动设置为1');
      }
    },
    
    // 接收父组件传递的字段配置
    setFieldConfig(fieldConfig) {
      console.log('接收到字段配置:', fieldConfig);
      
      if (fieldConfig && fieldConfig.length > 0) {
        if (this.fieldConfigProcessed) {
          // 如果已经处理过字段配置，先重置状态
          console.log('重新设置字段配置，触发自动刷新');
          this.fieldConfigProcessed = false;
          this.dynamicFields = [];
          this.fieldOptionsMap.clear();
          this.fieldRulesMap.clear();
          this.fieldCodeOptionsMap.clear();
          
          // 使用$nextTick确保DOM更新后再处理新配置
          this.$nextTick(() => {
            this.processFieldConfigImmediately(fieldConfig);
            this.pendingFieldConfig = null;
            
            // 再次强制刷新以确保字段正确显示
            setTimeout(() => {
              this.forceRerender();
            }, 100);
          });
        } else {
          this.pendingFieldConfig = fieldConfig;
        }
      } else {
        console.log('字段配置为空，使用默认字段设置');
        this.setupDefaultFields();
      }
    },
    
    // 处理等待中的字段配置
    processPendingFieldConfig() {
      if (this.pendingFieldConfig) {
        console.log('处理等待中的字段配置');
        
        // 先重置状态
        this.fieldConfigProcessed = false;
        this.dynamicFields = [];
        
        this.$nextTick(() => {
          this.processFieldConfigImmediately(this.pendingFieldConfig);
          this.pendingFieldConfig = null;
          
          // 延迟强制刷新
          setTimeout(() => {
            this.forceRerender();
            console.log('字段配置处理完成，已强制刷新');
          }, 150);
        });
      }
    },
    
    // 立即处理字段配置
    processFieldConfigImmediately(fieldConfig) {
      try {
        this.processFieldData(fieldConfig);
        this.fieldConfigLoaded = true;
        this.fieldConfigProcessed = true;
      } catch (error) {
        this.$message.error('字段配置处理失败');
        this.setupDefaultFields();
      }
    },
    
    // 处理字段数据
    processFieldData(fieldData) {
      try {
        const visibleFields = fieldData.filter(field =>
          field.isShow === 1 || field.isMustFill === 1 || field.isMustChoose === 1
        );
    
        this.dynamicFields = visibleFields.map(field => {
          // 特殊处理：如果字段代码是state或isBar，强制设置为下拉选择框
          if (field.fieldCode === 'state' || field.fieldCode === 'isBar') {
            field.inputBoxType = 'selected';
            console.log(`强制设置字段 ${field.fieldCode} 为下拉选择框`);
          }
          
          return {
            fieldCode: field.fieldCode,
            fieldName: field.fieldName || this.getDefaultFieldName(field.fieldCode),
            inputBoxType: field.inputBoxType || 'input',
            fieldType: field.fieldType || 'string',
            isShow: true,
            isMustFill: field.isMustFill || 0,
            isMustChoose: field.isMustChoose || 0,
            placeholder: field.placeholder || '',
            options: field.options || this.getDefaultFieldOptions(field.fieldCode),
            rules: this.generateFieldRules(field),
            colSpan: field.colSpan || 6,
            fieldCodeOption: field.fieldCodeOption || field.fieldCode
          };
        });
    
        this.buildFieldOptionsMap();
        this.buildFieldRulesMap();
        this.buildFieldCodeOptionsMap();
        this.fieldConfigProcessed = true;
        
        // 强制重新渲染组件
        this.forceRerender();
        
      } catch (error) {
        console.error('处理字段数据失败:', error);
        throw error;
      }
    },
    
	// 强制重新渲染组件
	forceRerender() {
	  console.log('强制重新渲染F2组件');
	  this.fieldRenderKey += 1;
	  this.$nextTick(() => {
	    this.$forceUpdate();
	  });
	},
	
    // 生成字段验证规则
    generateFieldRules(field) {
      const rules = [];
      
      if (this.isMarkUpRelatedField(field.fieldCode)) {
        const markUpRules = this.getMarkUpFieldRules(field);
        if (markUpRules) {
          rules.push(...markUpRules);
        }
      }
      
      if (field.isMustFill === 1 && field.inputBoxType === 'input') {
        rules.push({
          required: true,
          message: `请输入${field.fieldName}`,
          trigger: 'blur'
        });
      }
      
      if (field.isMustChoose === 1 && field.inputBoxType === 'selected') {
        rules.push({
          required: true,
          message: `请选择${field.fieldName}`,
          trigger: 'change'
        });
      }
      
      const typeRule = this.getFieldTypeRule(field);
      if (typeRule) {
        rules.push(typeRule);
      }
      
      const numberRule = this.getNumberFieldValidationRule(field);
      if (numberRule) {
        rules.push(numberRule);
      }
      
      const specificRule = this.getSpecificFieldRule(field);
      if (specificRule) {
        rules.push(specificRule);
      }
      
      return rules;
    },
    
    // 判断是否是加成相关字段
    isMarkUpRelatedField(fieldCode) {
      const markUpFields = ['markUpPric', 'markUpRate', 'markUpFixed'];
      return markUpFields.includes(fieldCode);
    },
    
    // 获取加成相关字段的验证规则
    getMarkUpFieldRules(field) {
      switch (field.fieldCode) {
        case 'markUpPric':
          return this.getMarkUpPricRules();
        case 'markUpRate':
          return this.getMarkUpRateRules();
        case 'markUpFixed':
          return this.getMarkUpFixedRules();
        default:
          return null;
      }
    },
    
    // 获取加成金额验证规则
    getMarkUpPricRules() {
      const rules = [];
      const markUpId = this.parseMarkUpId(this.form.markUpId);
      
      if (markUpId === 2) {
        rules.push({
          required: true,
          message: '固定加成模式下，加成金额为必填项',
          trigger: 'blur',
          validator: (rule, value, callback) => {
            if (!value && value !== 0) {
              callback(new Error('请输入加成金额'));
            } else if (isNaN(parseFloat(value))) {
              callback(new Error('加成金额必须是数字'));
            } else if (parseFloat(value) <= 0) {
              callback(new Error('加成金额必须大于0'));
            } else if (!Number.isInteger(Number(value))) {
              callback(new Error('加成金额必须是正整数'));
            } else {
              callback();
            }
          }
        });
      }
      
      return rules;
    },
    
    // 获取加成比例验证规则
    getMarkUpRateRules() {
      const rules = [];
      const markUpId = this.parseMarkUpId(this.form.markUpId);
      
      if (markUpId === 1 || markUpId === 3) {
        rules.push({
          required: true,
          message: '请输入加成比例',
          trigger: 'blur'
        });
        
        if (markUpId === 3) {
          // 手工加成模式：大于1小于2，最多3位小数
          rules.push({
            validator: this.validateManualMarkUpRate,
            message: '手工加成比例必须是大于1小于2的数字，最多3位小数',
            trigger: 'blur'
          });
        } else {
          // 比例加成模式
          rules.push({
            validator: this.validatePositiveNumber,
            message: '加成比例必须是大于0的数字',
            trigger: 'blur'
          });
        }
      }
      
      return rules;
    },
    
    // 获取固定加成验证规则
    getMarkUpFixedRules() {
      const rules = [];
      const markUpId = this.parseMarkUpId(this.form.markUpId);
      
      if (markUpId === 2) {
        rules.push({
          required: true,
          message: '固定加成模式下，请选择是否固定加成',
          trigger: 'change',
          validator: (rule, value, callback) => {
            if (value === '' || value === null || value === undefined) {
              callback(new Error('请选择是否固定加成'));
            } else if (value !== 1) {
              callback(new Error('固定加成模式下必须选择"是"'));
            } else {
              callback();
            }
          }
        });
      }
      
      return rules;
    },
    
    // 手工比例加成的正整数验证器
    validatePositiveIntegerForManualMarkUp(rule, value, callback) {
      if (!value && value !== 0) {
        callback(new Error('请输入加成比例'));
        return;
      }
      
      const intValue = parseInt(value);
      if (isNaN(intValue)) {
        callback(new Error('加成比例必须是整数'));
        return;
      }
      
      if (!Number.isInteger(Number(value)) || intValue <= 0) {
        callback(new Error('加成比例必须是大于0的正整数'));
        return;
      }
      
      if (parseFloat(value) !== intValue) {
        callback(new Error('加成比例不能包含小数'));
        return;
      }
      
      callback();
    },
    
    // 正数验证器
    validatePositiveNumber(rule, value, callback) {
      if (!value && value !== 0) {
        callback(new Error('请输入数值'));
        return;
      }
      
      const numValue = parseFloat(value);
      if (isNaN(numValue) || numValue <= 0) {
        callback(new Error('必须是大于0的数字'));
      } else {
        callback();
      }
    },
    
    // 获取字段类型验证规则
    getFieldTypeRule(field) {
      const fieldType = field.fieldType || 'string';
      
      switch (fieldType) {
        case 'Integer':
          return {
            validator: this.validateInteger,
            message: `${field.fieldName}必须是大于0的正整数`,
            trigger: 'blur'
          };
        case 'Number':
          return {
            validator: this.validateNumber,
            message: `${field.fieldName}必须是数字`,
            trigger: 'blur'
          };
        case 'Decimal':
          return {
            validator: this.validateDecimal,
            message: `${field.fieldName}必须是小数`,
            trigger: 'blur'
          };
        default:
          return null;
      }
    },
    
    // 正整数验证器
    validateInteger(rule, value, callback) {
      if (value === '' || value === null || value === undefined) {
        callback();
        return;
      }
      
      const integerRegex = /^[0-9]\d*$/;
      if (!integerRegex.test(value)) {
        callback(new Error(rule.message || '必须是正整数'));
      } else {
        callback();
      }
    },
    
    // 数字验证器
    validateNumber(rule, value, callback) {
      if (value === '' || value === null || value === undefined) {
        callback();
        return;
      }
      
      const numberRegex = /^-?\d+(\.\d+)?$/;
      if (!numberRegex.test(value)) {
        callback(new Error(rule.message || '必须是数字'));
      } else {
        callback();
      }
    },
    
    // 小数验证器
    validateDecimal(rule, value, callback) {
      if (value === '' || value === null || value === undefined) {
        callback();
        return;
      }
      
      const decimalRegex = /^-?\d+(\.\d+)?$/;
      if (!decimalRegex.test(value)) {
        callback(new Error(rule.message || '必须是小数'));
      } else {
        callback();
      }
    },
    
    // 获取数字字段校验规则
    getNumberFieldValidationRule(field) {
      const numberFields = [
        'unitDose', 'pacCnt', 'minDose', 'fixMinSalePric', 'fixPacSalePric',
        'costPric', 'salePric', 'markUpRate', 'markUpPric'
      ];
      
      if (!numberFields.includes(field.fieldCode)) {
        return null;
      }
      
      return {
        validator: (rule, value, callback) => {
          if (value === '' || value === null || value === undefined) {
            callback();
            return;
          }
          
          const numValue = parseFloat(value);
          if (isNaN(numValue)) {
            callback(new Error(`${field.fieldName}必须是有效的数字`));
            return;
          }
          
          if (field.fieldCode === 'pacCnt') {
            if (!Number.isInteger(numValue) || numValue <= 0) {
              callback(new Error('包装数量必须是大于0的正整数'));
              return;
            }
          }
          
          if (numValue < 0) {
            callback(new Error(`${field.fieldName}不能为负数`));
            return;
          }
          
          callback();
        },
        trigger: 'blur'
      };
    },
    
    // 获取特定字段的验证规则
    getSpecificFieldRule(field) {
      const specificRules = {
        'code': [{
          validator: (rule, value, callback) => {
            if (value && value.length > 50) {
              callback(new Error('编码长度不能超过50个字符'));
            } else {
              callback();
            }
          },
          trigger: 'blur'
        }],
        'drugName': [{
          validator: (rule, value, callback) => {
            if (value && value.length > 100) {
              callback(new Error('药品名称长度不能超过100个字符'));
            } else {
              callback();
            }
          },
          trigger: 'blur'
        }]
      };
      
      return specificRules[field.fieldCode] || null;
    },
    
    // 构建字段验证规则映射
    buildFieldRulesMap() {
      this.fieldRulesMap.clear();
      this.dynamicFields.forEach(field => {
        if (field.rules && field.rules.length > 0) {
          this.fieldRulesMap.set(field.fieldCode, field.rules);
        }
      });
    },
    
    // 获取字段的验证规则
    getFieldRules(field) {
      return this.fieldRulesMap.get(field.fieldCode) || [];
    },
    
    // 构建字段选项映射
    buildFieldOptionsMap() {
      this.fieldOptionsMap.clear();
      this.dynamicFields.forEach(field => {
        if (field.options && field.options.length > 0) {
          this.fieldOptionsMap.set(field.fieldCode, field.options);
        }
      });
    },
    
    // 构建字段代码选项映射
    buildFieldCodeOptionsMap() {
      this.fieldCodeOptionsMap.clear();
      this.dynamicFields.forEach(field => {
        if (field.inputBoxType === 'selected') {
          const optionsArray = this.getOptionsByFieldCodeOption(field.fieldCodeOption);
          if (optionsArray && optionsArray.length > 0) {
            this.fieldCodeOptionsMap.set(field.fieldCode, optionsArray);
          }
        }
      });
    },
    
    // 获取选项
    getOptionsByFieldCodeOption(fieldCodeOption) {
      const optionsMap = {
        'isBar': this.YNoptions, // 是否启用追溯码
        'manualPric': this.YNoptions,
        'isFixPrice': this.YNoptions,
        'minUnt': this.minUnt,
        'dosUnt': this.dosUnt,
        'pacUnt': this.allUnitOptions,
        'saleUnt': this.saleWaysOptions,
        'medcWay': this.medcWayIdOptions,
        'usedFrquId': this.usedFrquIdOptions,
        'markUpId': this.markUpOption,
        'markUpFixed': this.YNoptions,
        'expensiveType': this.expensiveTypeOptions,
        'roundUnt': this.roundUntoptions,
        'mrsId': this.medicalRecordFeeOption,
        'intxAnstType': this.poisonousTypeOption,
        'state': this.statusOptions, // 有效状态
        'lmtc': this.lmtSpc,
        'nurtureType': this.nurtureType,
        'antcLv': this.antcLvOption,
      };
      
      return optionsMap[fieldCodeOption] || [];
    },
    
    // 获取字段选项
    getFieldOptions(field) {
      if (this.fieldCodeOptionsMap.has(field.fieldCode)) {
        return this.fieldCodeOptionsMap.get(field.fieldCode);
      }
      
      if (field.options && field.options.length > 0) {
        return field.options;
      }
      
      return this.getDefaultFieldOptions(field.fieldCode);
    },
    
    // 重新构建字段映射
    rebuildFieldMaps() {
      this.buildFieldOptionsMap();
      this.buildFieldRulesMap();
      this.buildFieldCodeOptionsMap();
    },
    
	// 判断是否已在必填区域显示的字段
	isRequiredField(fieldCode) {
	  const requiredFieldCodes = [
		'drugName', 'code', 'pacCnt', 'pacSpec',
		'pacUnt', 'unitDose', 'dosUnt', 'minDose',
		'minUnt', 'saleUnt', 'manualPric', 'isFixPrice',
		'markUpId', 'markUpRate', 'markUpPric', 'roundUnt'
	  ];
	  return requiredFieldCodes.includes(fieldCode);
	},
	
	// 修改第三行显示逻辑的方法名
	showFourthRowMarkUpField() {
	  const markUpId = this.parseMarkUpId(this.form.markUpId);
	  
	  if (markUpId === 2) {
		// 固定加成模式：检查markUpPric字段
		const field = this.dynamicFields.find(f => f.fieldCode === 'markUpPric');
		
		if (field && field.isShow === 1) {
		  return true;
		}
		
		// 即使字段配置中isShow不为1，在固定加成模式下也应该显示
		return true;
	  } else if (markUpId === 1 || markUpId === 3) {
		// 比例加成或手工比例加成模式：检查markUpRate字段
		const field = this.dynamicFields.find(f => f.fieldCode === 'markUpRate');
		
		if (field && field.isShow === 1) {
		  return true;
		}
		
		// 即使字段配置中isShow不为1，在比例加成模式下也应该显示
		return true;
	  }
	  
	  return false;
	},
	
	// 计算第三行的列宽
	getThirdRowColSpan() {
	  // 如果指定售价为1，显示6个字段，每个字段占4列
	  // 如果指定售价为0，显示4个字段，每个字段占6列
	  return this.form.isFixPrice == 1 ? 4 : 6;
	},
	
	// 获取指定售价相关字段的验证规则
	getFixPriceValidationRules(fieldCode) {
	  const rules = [];
	  
	  if (this.form.isFixPrice == 1) {
	    rules.push({
	      required: true,
	      message: `请输入${fieldCode === 'fixPacSalePric' ? '包装指定售价' : '最小指定售价'}`,
	      trigger: 'blur'
	    });
	    
	    rules.push({
	      validator: (rule, value, callback) => {
	        this.validateFixPrice(rule, value, callback, fieldCode);
	      },
	      message: '指定售价必须是大于0的数字，最多2位小数',
	      trigger: 'blur'
	    });
	  }
	  
	  return rules;
	},
	
	// 验证指定售价
	validateFixPrice(rule, value, callback, fieldCode) {
	  if (!value && value !== 0) {
	    callback(new Error(`请输入${fieldCode === 'fixPacSalePric' ? '包装指定售价' : '最小指定售价'}`));
	    return;
	  }
	  
	  const numValue = parseFloat(value);
	  if (isNaN(numValue)) {
	    callback(new Error('指定售价必须是数字'));
	    return;
	  }
	  
	  // 必须大于0
	  if (numValue <= 0) {
	    callback(new Error('指定售价必须大于0'));
	    return;
	  }
	  
	  // 检查小数位数
	  const decimalPlaces = (value.toString().split('.')[1] || '').length;
	  if (decimalPlaces > 2) {
	    callback(new Error('指定售价最多支持2位小数'));
	    return;
	  }
	  
	  callback();
	},
	
	// 处理指定售价变化
	handleIsFixPriceChange(value) {
	  this.handleFieldChange({fieldCode: 'isFixPrice'}, value);
	},
	
    // 设置默认字段
    setupDefaultFields() {
      console.log('设置默认字段');
      
      const defaultFields = [
        { fieldCode: 'code', fieldName: '编码', inputBoxType: 'input', isShow: 1, isMustFill: 1, fieldCodeOption: 'code' },
        { fieldCode: 'drugName', fieldName: '药品名称', inputBoxType: 'input', isShow: 1, isMustFill: 1, fieldCodeOption: 'drugName' },
        { fieldCode: 'pyCode', fieldName: '拼音简码', inputBoxType: 'input', isShow: 1, isMustFill: 0, fieldCodeOption: 'pyCode' },
        { fieldCode: 'alis', fieldName: '药品别名', inputBoxType: 'input', isShow: 1, isMustFill: 0, fieldCodeOption: 'alis' },
        { fieldCode: 'alisPyCode', fieldName: '别名简码', inputBoxType: 'input', isShow: 1, isMustFill: 0, fieldCodeOption: 'alisPyCode' },
        { fieldCode: 'state', fieldName: '有效状态', inputBoxType: 'selected', isShow: 1, isMustChoose: 1, fieldCodeOption: 'state' }, // 改为下拉选择框
        { fieldCode: 'drugSpec', fieldName: '药品规格', inputBoxType: 'input', isShow: 1, isMustFill: 0, fieldCodeOption: 'drugSpec' },
        { fieldCode: 'pacSpec', fieldName: '包装规格', inputBoxType: 'input', isShow: 1, isMustFill: 1, fieldCodeOption: 'pacSpec' },
        { fieldCode: 'pacUnt', fieldName: '包装单位', inputBoxType: 'selected', isShow: 1, isMustChoose: 1, fieldCodeOption: 'pacUnt' },
        { fieldCode: 'pacCnt', fieldName: '包装数量', inputBoxType: 'input', isShow: 1, isMustFill: 1, fieldCodeOption: 'pacCnt' },
        { fieldCode: 'minUnt', fieldName: '最小单位', inputBoxType: 'selected', isShow: 1, isMustChoose: 1, fieldCodeOption: 'minUnt' },
        { fieldCode: 'minDose', fieldName: '最小剂量', inputBoxType: 'input', isShow: 1, isMustFill: 1, fieldCodeOption: 'minDose' },
        { fieldCode: 'costPric', fieldName: '成本单价', inputBoxType: 'input', isShow: 1, isMustFill: 1, fieldCodeOption: 'costPric' },
        { fieldCode: 'salePric', fieldName: '零售单价', inputBoxType: 'input', isShow: 1, isMustFill: 1, fieldCodeOption: 'salePric' },
        { fieldCode: 'saleUnt', fieldName: '零售单位', inputBoxType: 'selected', isShow: 1, isMustChoose: 1, fieldCodeOption: 'saleUnt' },
        { fieldCode: 'medcWayId', fieldName: '给药方式', inputBoxType: 'selected', isShow: 1, isMustChoose: 0, fieldCodeOption: 'medcWayId' },
        { fieldCode: 'usedFrquId', fieldName: '用药频率', inputBoxType: 'selected', isShow: 1, isMustChoose: 0, fieldCodeOption: 'usedFrquId' },
        { fieldCode: 'markUpId', fieldName: '加成方式', inputBoxType: 'selected', isShow: 1, isMustChoose: 1, fieldCodeOption: 'markUpId' },
        { fieldCode: 'markUpFixed', fieldName: '固定加成', inputBoxType: 'selected', isShow: 1, isMustChoose: 0, fieldCodeOption: 'markUpFixed' },
        { fieldCode: 'markUpRate', fieldName: '加成比例', inputBoxType: 'input', isShow: 1, isMustFill: 0, fieldCodeOption: 'markUpRate' },
        { fieldCode: 'markUpPric', fieldName: '加成金额', inputBoxType: 'input', isShow: 1, isMustFill: 0, fieldCodeOption: 'markUpPric' },
        { fieldCode: 'expensiveType', fieldName: '贵重类型', inputBoxType: 'selected', isShow: 1, isMustChoose: 0, fieldCodeOption: 'expensiveType' },
        { fieldCode: 'roundUnt', fieldName: '取整方式', inputBoxType: 'selected', isShow: 1, isMustChoose: 1, fieldCodeOption: 'roundUnt' },
        { fieldCode: 'mrsId', fieldName: '病案费别', inputBoxType: 'selected', isShow: 1, isMustChoose: 1, fieldCodeOption: 'mrsId' },
        { fieldCode: 'intxAnstType', fieldName: '毒麻类型', inputBoxType: 'selected', isShow: 1, isMustChoose: 0, fieldCodeOption: 'intxAnstType' },
        { fieldCode: 'lmtSpc', fieldName: '适用范围', inputBoxType: 'selected', isShow: 1, isMustChoose: 0, fieldCodeOption: 'lmtSpc' },
        { fieldCode: 'isBar', fieldName: '是否启用追溯码', inputBoxType: 'selected', isShow: 1, isMustChoose: 0, fieldCodeOption: 'isBar' }, // 改为下拉选择框
      ];
      
      this.processFieldData(defaultFields);
    },
    
    // 获取默认字段名称
    getDefaultFieldName(fieldCode) {
      const fieldNameMap = {
        'code': '编码',
        'drugName': '药品名称',
        'pyCode': '拼音简码',
        'alis': '药品别名',
        'alisPyCode': '别名简码',
        'state': '有效状态',
        'drugSpec': '药品规格',
        'pacSpec': '包装规格',
        'unitDose': '单位剂量',
        'dosUntOption': '剂量单位',
        'pacUnt': '包装单位',
        'pacCnt': '包装数量',
        'minUnt': '最小单位',
        'minDose': '最小剂量',
        'costPric': '成本单价',
        'salePric': '零售单价',
        'saleUnt': '零售单位',
        'medcWayId': '给药方式',
        'usedFrquId': '用药频率',
        'tcmB': '内服药',
        'markUpId': '加成方式',
        'markUpFixed': '固定加成',
        'markUpRate': '加成比例',
        'markUpPric': '加成金额',
        'expensiveType': '贵重类型',
        'roundUnt': '取整方式',
        'mrsId': '病案费别',
        'intxAnstType': '毒麻类型',
        'phamType': '药理类别',
        'lmtSpc': '适用范围',
      };
      
      return fieldNameMap[fieldCode] || fieldCode;
    },
    
    // 获取默认字段选项
    getDefaultFieldOptions(fieldCode) {
      const optionsMap = {
        'state': this.statusOptions,
        'saleUnt': this.saleWaysOptions,
        'markUpId': this.markUpOption,
        'markUpFixed': this.YNoptions,
        'isBar': this.YNoptions, // 新增：是否启用追溯码选项
        'tcmB': this.YNoptions,
        'expensiveType': this.expensiveTypeOptions,
        'roundUnt': this.roundUntoptions,
        'mrsId': this.medicalRecordFeeOption,
        'intxAnstType': this.poisonousTypeOption,
        'medcWayId': this.usedFrquIdOptions,
        'usedFrquId': this.medcWayIdOptions,
        'lmtSpc': this.lmtSpc,
        'nurtureType': this.nurtureType,
        'antcLv': this.antcLvOption,
        'dosUnt': this.dosUnt,
        'minUnt': this.minUnt,
      };
      
      return optionsMap[fieldCode] || [];
    },
    
    // 获取数字字段的CSS类
    getNumberFieldClass(field) {
      const numberFields = [
        'unitDose', 'pacCnt', 'minDose', 'fixMinSalePric', 'fixPacSalePric',
        'costPric', 'salePric', 'markUpRate', 'markUpPric'
      ];
      
      if (numberFields.includes(field.fieldCode)) {
        return 'number-input-field';
      }
      return '';
    },
    
    // 获取数字精度
    getNumberPrecision(field) {
      const precisionMap = {
        'unitDose': 4,
        'minDose': 4,
        'fixMinSalePric': 2,
        'fixPacSalePric': 2,
        'costPric': 4,
        'salePric': 4,
        'markUpRate': 4,
        'markUpPric': 2
      };
      
      return precisionMap[field.fieldCode] || 2;
    },
    
    // 获取数字最小值
    getNumberMin(field) {
      if (field.fieldCode === 'pacCnt') {
        return 1;
      }
      return 0;
    },
    
    // 获取数字最大值
    getNumberMax(field) {
      const maxMap = {
        'pacCnt': 999999,
        'unitDose': 999999,
        'minDose': 999999,
        'fixMinSalePric': 999999,
        'fixPacSalePric': 999999,
        'costPric': 999999,
        'salePric': 999999,
        'markUpRate': 1000,
        'markUpPric': 999999
      };
      
      return maxMap[field.fieldCode] || 999999;
    },
    
    // 获取数字步长
    getNumberStep(field) {
      if (field.fieldCode === 'pacCnt') {
        return 1;
      }
      return 0.01;
    },
    
    // 获取字段占位符
    getFieldPlaceholder(field) {
      return field.placeholder || `请输入${field.fieldName}`;
    },
    
    // 强制重新渲染字段
    forceReRenderFields() {
      this.fieldRenderKey++;
    },
    
    // 强制更新验证规则
    forceUpdateValidationRules() {
      this.buildFieldRulesMap();
      if (this.$refs.form) {
        this.$nextTick(() => {
          this.$refs.form.clearValidate();
        });
      }
    },
    
    // 重新构建验证规则
    rebuildValidationRules() {
      this.addRules = this.generateMarkUpValidationRules();
    },
    
    // 生成加成相关字段的验证规则
    generateMarkUpValidationRules() {
      const rules = {};
      const markUpId = this.parseMarkUpId(this.form.markUpId);
      
      switch (markUpId) {
        case 1:
          rules.markUpRate = [
            { required: true, message: '比例加成模式下，加成比例为必填项', trigger: 'blur' },
            { validator: this.validatePositiveNumber, message: '加成比例必须是大于0的数字', trigger: 'blur' }
          ];
          rules.markUpPric = [];
          rules.markUpFixed = [];
          break;
        case 2:
          rules.markUpRate = [];
          rules.markUpPric = [
            { required: true, message: '固定加成模式下，加成金额为必填项', trigger: 'blur' },
            { validator: this.validatePositiveNumber, message: '加成金额必须是大于0的数字', trigger: 'blur' }
          ];
          rules.markUpFixed = [
            { required: true, message: '固定加成模式下，请选择是否固定加成', trigger: 'change' }
          ];
          break;
        case 3:
          rules.markUpRate = [
            { required: true, message: '手工比例加成模式下，加成比例为必填项', trigger: 'blur' },
            { validator: this.validatePositiveInteger, message: '加成比例必须是大于0的正整数', trigger: 'blur' }
          ];
          rules.markUpPric = [];
          rules.markUpFixed = [];
          break;
        case 4:
          rules.markUpRate = [];
          rules.markUpPric = [];
          rules.markUpFixed = [];
          break;
        default:
          rules.markUpRate = [];
          rules.markUpPric = [];
          rules.markUpFixed = [];
      }
      
      return rules;
    },
    
    // 正整数验证器
    validatePositiveInteger(rule, value, callback) {
      if (!value && value !== 0) {
        callback(new Error('请输入加成比例'));
        return;
      }
      
      const intValue = parseInt(value);
      if (isNaN(intValue) || intValue <= 0 || !Number.isInteger(intValue)) {
        callback(new Error('加成比例必须是大于0的正整数'));
      } else {
        callback();
      }
    },
    
    // 清除表单验证
    clearFormValidation() {
      if (this.$refs.form) {
        this.$nextTick(() => {
          this.$refs.form.clearValidate(['markUpRate', 'markUpPric', 'markUpFixed']);
        });
      }
    },
    
    // 更新表单
    updateForm() {
      this.$emit('update', this.form);
    },
    
    // 获取字符串的首字母
    getFirstLetter(str) {
      if (!str || typeof str !== 'string') return '';
      
      try {
        const chineseChars = str.match(/[\u4e00-\u9fa5]/g) || [];
        if (chineseChars.length === 0) return '';
        
        const initials = chineseChars.map(char => {
          const pinyinResult = pinyin(char, {
            toneType: 'none',
            type: 'array',
            multiple: false,
          })[0] || '';
          return pinyinResult.charAt(0).toUpperCase();
        });
        
        return initials.join('');
      } catch (error) {
        console.error('拼音转换失败:', error);
        return '';
      }
    },
    
    // 药理类别相关方法
    async loadFirstLevelPhamTypes() {
      try {
        this.loadingPhamTypes = true;
        const res = await selectOneCateGory({});
        
        if (res.code === 200) {
          this.phamTypeOptions = res.data.map(item => ({
            id: item.id,
            label: item.name || item.label,
            value: item.id,
            leaf: false,
            level: 1,
            idcode: item.idcode || item.id
          }));
          
          this.phamTypeOptions.forEach(item => {
            this.phamTypeCache.set(`1_${item.id}`, item);
          });
        }
      } catch (error) {
        console.error('加载一级药理类别出错:', error);
        this.$message.error('加载药理类别失败');
      } finally {
        this.loadingPhamTypes = false;
      }
    },
    
    // 懒加载子节点
    async loadPhamTypeChildren(node, resolve) {
      const { level, data } = node;
      
      try {
        let res;
        let children = [];
        
        if (level === 0) {
          resolve(this.phamTypeOptions);
          return;
        } else if (level === 1) {
          res = await selectTwoCateGory({
            idcode: data.idcode || data.id
          });
        } else if (level === 2) {
          res = await selectThreeCateGory({
            idcode: data.idcode || data.id
          });
        } else {
          resolve([]);
          return;
        }
        
        if (res.code === 200) {
          children = res.data.map(item => ({
            id: item.id,
            label: item.name || item.label,
            value: item.id,
            leaf: level === 2,
            level: level + 1,
            idcode: item.idcode || item.id
          }));
          
          children.forEach(child => {
            this.phamTypeCache.set(`${level + 1}_${child.id}`, child);
          });
        }
        
        resolve(children);
      } catch (error) {
        console.error('加载药理子类别出错:', error);
        this.$message.error('加载子类别失败');
        resolve([]);
      }
    },
    
    // 处理级联选择变化
    handlePhamTypeChange(value) {
      if (!value || value.length === 0) {
        this.form.phamType1 = '';
        this.form.phamType2 = '';
        this.form.phamType3 = '';
        this.updateForm();
        return;
      }
      
      if (value.length >= 1) {
        this.form.phamType1 = value[0];
      } else {
        this.form.phamType1 = '';
      }
      
      if (value.length >= 2) {
        this.form.phamType2 = value[1];
      } else {
        this.form.phamType2 = '';
      }
      
      if (value.length >= 3) {
        this.form.phamType3 = value[2];
      } else {
        this.form.phamType3 = '';
      }
      
      this.updateForm();
    },
    
    // 初始化级联选择器值
    async initPhamTypeValue() {
      if (!this.form.phamType1) {
        this.phamTypeValue = [];
        return;
      }
      
      try {
        const path = [];
        
        if (this.form.phamType1) {
          const level1 = await this.loadPhamTypeById(this.form.phamType1, 1);
          if (level1) {
            path.push(level1.id);
            
            if (this.form.phamType2) {
              const level2 = await this.loadPhamTypeById(this.form.phamType2, 2, level1.id);
              if (level2) {
                path.push(level2.id);
                
                if (this.form.phamType3) {
                  const level3 = await this.loadPhamTypeById(this.form.phamType3, 3, level2.id);
                  if (level3) {
                    path.push(level3.id);
                  }
                }
              }
            }
          }
        }
        
        this.phamTypeValue = path;
      } catch (error) {
        console.error('初始化药理类别失败:', error);
        this.phamTypeValue = [];
      }
    },
    
    // 根据ID加载药理类别数据
    async loadPhamTypeById(id, level, parentId = null) {
      const cacheKey = `${level}_${id}`;
      
      if (this.phamTypeCache.has(cacheKey)) {
        return this.phamTypeCache.get(cacheKey);
      }
      
      try {
        let res;
        let foundItem = null;
        
        if (level === 1) {
          if (this.phamTypeOptions.length === 0) {
            await this.loadFirstLevelPhamTypes();
          }
          
          foundItem = this.phamTypeOptions.find(item => item.id == id);
        } else if (level === 2) {
          res = await selectTwoCateGory({
            idcode: parentId
          });
          if (res.code === 200) {
            foundItem = res.data.find(item => item.id == id);
            if (foundItem) {
              foundItem = {
                id: foundItem.id,
                label: foundItem.name || foundItem.label,
                value: foundItem.id,
                leaf: false,
                level: 2,
                idcode: foundItem.idcode || foundItem.id
              };
            }
          }
        } else if (level === 3) {
          res = await selectThreeCateGory({
            idcode: parentId
          });
          if (res.code === 200) {
            foundItem = res.data.find(item => item.id == id);
            if (foundItem) {
              foundItem = {
                id: foundItem.id,
                label: foundItem.name || foundItem.label,
                value: foundItem.id,
                leaf: true,
                level: 3,
                idcode: foundItem.idcode || foundItem.id
              };
            }
          }
        }
        
        if (foundItem) {
          this.phamTypeCache.set(cacheKey, foundItem);
          return foundItem;
        }
      } catch (error) {
        console.error('加载药理类别失败:', error);
      }
      
      return null;
    },
    
    // 处理级联选择器显示/隐藏
    handleCascaderVisible(visible) {
      if (visible && this.phamTypeOptions.length === 0) {
        this.loadFirstLevelPhamTypes();
      }
    },
    
    // 获取级联选择器选项
    getCascaderOptions(field) {
      if (field.fieldCode === 'phamType') {
        return this.phamTypeOptions;
      }
      return field.options || [];
    },
    
    // 获取级联选择器属性
    getCascaderProps(field) {
      if (field.fieldCode === 'phamType') {
        return this.cascaderProps;
      }
      return {
        value: 'value',
        label: 'label',
        children: 'children'
      };
    },
    
    // 获取日期选择器类型
    getDatePickerType(field) {
      return field.dateType || 'datetime';
    },
    
    // 判断是否显示特殊字段
    shouldShowSpecialField(fieldCode) {
      const field = this.dynamicFields.find(f => f.fieldCode === fieldCode);
      return field && field.isShow && this.specialFields.includes(fieldCode);
    },
    
    // 处理选择器变化
    handleSelectChange(field, value) {
      this.handleFieldChange(field, value);
    },
    
    // 比例加成重置
    handleProportionalMarkUpWithReset() {
      this.setMarkUpFieldState({
        markUpRate: false,
        markUpPric: true,
        markUpFixed: true
      });
      
      this.form.markUpPric = '0';
      this.form.markUpFixed = 0;
      
      this.$nextTick(() => {
        this.calculateSalePrice();
      });
    },
    
    // 手工比例加成重置
    handleManualProportionalMarkUpWithReset() {
      this.setMarkUpFieldState({
        markUpRate: false,
        markUpPric: true,
        markUpFixed: true
      });
      
      if (!this.form.markUpRate || this.form.markUpRate === '') {
        this.form.markUpRate = '1';
      }
      
      this.form.markUpPric = '0';
      this.form.markUpFixed = 0;
      
      this.$nextTick(() => {
        this.calculateSalePriceForManualMarkUp();
      });
    }
  }
};
</script>

<style lang="less" scoped>
.basic-info {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  
  .basic-info-container {
    flex: 1;
    display: flex;
    flex-direction: column;
    min-height: 0; /* 允许收缩 */
    
    .el-form {
      width: 100%;
      height: auto; /* 改为auto，让内容自然展开 */
      display: flex;
      flex-direction: column;
      
      /* 确保所有表单字段标签左对齐 */
      .el-form-item {
        .el-form-item__label {
          text-align: left;
          justify-content: flex-start;
        }
        
        .el-form-item__content {
          .el-input__inner,
          .el-textarea__inner,
          .el-select .el-input__inner {
            text-align: left;
          }
        }
      }
      
      /* 整个表单的滚动容器 */
      .form-scroll-container {
        flex: 1;
        min-height: 0;
        overflow-y: auto;
        overflow-x: hidden;
        border: 1px solid #e8e8e8;
        border-radius: 4px;
        padding: 12px;
        box-sizing: border-box;
        
        /* 滚动条样式 */
        &::-webkit-scrollbar {
          width: 8px;
          height: 8px;
        }
        
        &::-webkit-scrollbar-track {
          background: #f5f5f5;
          border-radius: 4px;
        }
        
        &::-webkit-scrollbar-thumb {
          background: #c1c1c1;
          border-radius: 4px;
          
          &:hover {
            background: #a8a8a8;
          }
        }
        
        /* 针对Firefox的滚动条样式 */
        scrollbar-width: thin;
        scrollbar-color: #c1c1c1 #f5f5f5;
        
        /* 动态表单字段样式调整 - 与标签页名称对齐 */
        .el-form-item {
          .el-form-item__label {
            text-align: left;
            justify-content: flex-start;
            padding-left: 0; /* 移除左侧空白 */
            padding-right: 8px;
          }
        }
        
        /* 必填字段行 */
        .required-fields-row {
          
          .el-col {
            margin-bottom: 8px;
            
            .form-item-adaptive {
              margin-bottom: 0;
              display: flex;
              align-items: stretch;
              height: 100%;
              
              ::v-deep .el-form-item__label {
                background-color: #f5f7fa;
                border: 1px solid #dcdfe6;
                border-right: none;
                padding: 0 8px;
                line-height: 32px;
                height: 100%;
                font-weight: bold;
                color: #00557f;
                width: auto;
                min-width: 100px;
                max-width: 150px;
                text-align: left; /* 确保左对齐 */
                display: flex;
                align-items: center;
                justify-content: flex-start; /* 确保左对齐 */
                font-size: 12px;
                border-top-left-radius: 4px;
                border-bottom-left-radius: 4px;
                white-space: normal;
                word-break: break-word;
                overflow-wrap: break-word;
                flex-shrink: 0;
              }
              
              ::v-deep .el-form-item__content {
                border: 1px solid #dcdfe6;
                border-left: none;
                line-height: 32px;
                height: 100%;
                flex: 1;
                margin-left: 0 !important;
                display: flex;
                align-items: center;
                border-top-right-radius: 4px;
                border-bottom-right-radius: 4px;
                
                .compact-input,
                .compact-select {
                  width: 100%;
                  height: 100%;
                  
                  .el-input__inner {
                    border: none;
                    height: 100%;
                    line-height: 30px;
                    padding: 0 8px;
                    font-size: 12px;
                    color: #606266;
                    text-align: left; /* 输入框内容左对齐 */
                  }
                  
                  /* 为包装单位、剂量单位、最小单位的下拉框添加自定义类名 */
                  &.pac-unt-select,
                  &.dos-unt-select,
                  &.min-unt-select {
                    /* 添加自定义类名以便全局样式可以应用 */
                  }
                }
              }
            }
          }
        }
        
        /* 非必填字段区域 */
        .optional-fields-section {
          border-top: 1px solid #e8e8e8;
          padding-top: 8px;
          margin-top: 8px;
          
          .dynamic-fields-grid {
			  /* 金额字段特殊样式 */
			  .cost-price-col,
			  .sale-price-col {
				.form-item-adaptive.amount-field {
				  ::v-deep .el-form-item__label {
					color: #ff0000; /* 红色标签 */
					font-weight: bold;
				  }
				  
				  ::v-deep .el-form-item__content {
					.amount-input {
					  .el-input__inner {
						color: #ff0000; /* 红色文字 */
						font-weight: bold;
					  }
					  
					  .amount-suffix {
						color: #ff0000; /* 红色￥符号 */
						font-weight: bold;
						padding-right: 8px;
					  }
					}
				  }
				}
			}
            .field-col {
              
              .form-item-adaptive {
                margin-bottom: 8px;
                display: flex;
                align-items: stretch;
                height: 100%;
                
                ::v-deep .el-form-item__label {
                  background-color: #f5f7fa;
                  border: 1px solid #dcdfe6;
                  border-right: none;
                  padding: 0 8px;
                  line-height: 32px;
                  height: 100%;
                  font-weight: bold;
                  color: #00557f;
                  width: auto;
                  min-width: 100px;
                  max-width: 150px;
                  text-align: left; /* 确保左对齐 */
                  display: flex;
                  align-items: center;
                  justify-content: flex-start; /* 确保左对齐 */
                  font-size: 12px;
                  border-top-left-radius: px;
                  border-bottom-left-radius: 4px;
                  white-space: normal;
                  word-break: break-word;
                  overflow-wrap: break-word;
                  flex-shrink: 0;
                }
                
                ::v-deep .el-form-item__content {
                  border: 1px solid #dcdfe6;
                  border-left: none;
                  line-height: 32px;
                  height: 100%;
                  flex: 1;
                  margin-left: 0 !important;
                  display: flex;
                  align-items: center;
                  border-top-right-radius: 4px;
                  border-bottom-right-radius: 4px;
                  
                  .compact-input,
                  .compact-select,
                  .compact-cascader,
                  .compact-datepicker {
                    width: 100%;
                    height: 100%;
                    
                    .el-input__inner {
                      border: none;
                      height: 100%;
                      line-height: 30px;
                      padding: 0 8px;
                      font-size: 12px;
                      color: #606266;
                      text-align: left; /* 输入框内容左对齐 */
                    }
                    
                    /* 为包装单位、剂量单位、最小单位的下拉框添加自定义类名 */
                    &.pac-unt-select,
                    &.dos-unt-select,
                    &.min-unt-select {
                      /* 添加自定义类名以便全局样式可以应用 */
                    }
                  }
                  
                  .compact-input-number {
                    width: 100%;
                    
                    .el-input-number__decrease,
                    .el-input-number__increase {
                      display: none;
                    }
                    
                    .el-input__inner {
                      border: none;
                      height: 30px;
                      line-height: 30px;
                      padding: 0 8px;
                      font-size: 12px;
                      color: #606266;
                      text-align: left; /* 输入框内容左对齐 */
                    }
                  }
                  
                  .compact-checkbox {
                    font-size: 12px;
                    color: #606266;
                    text-align: left; /* 复选框内容左对齐 */
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>

<style>
/* 包装单位、剂量单位、最小单位下拉选择框样式 - 全局样式 */
.custom-unit-dropdown.el-select-dropdown {
  min-width: 168px !important;
  max-width: 268px !important;
}

.custom-unit-dropdown.el-select-dropdown .el-select-dropdown__list {
  display: flex !important;
  flex-wrap: wrap !important;
  padding: 6px !important;
  margin: 0;
  justify-content: space-between;
}

.custom-unit-dropdown.el-select-dropdown .el-select-dropdown__item {
  flex: 0 0 calc(25% - 8px) !important; /* 每行显示4个选项，每个占25%减去边距 */
  box-sizing: border-box;
  padding: 8px 4px;
  margin: 4px;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  text-align: center;
  height: auto;
  min-height: 36px;
  line-height: 1.4;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fff;
}

.custom-unit-dropdown.el-select-dropdown .el-select-dropdown__item:hover {
  background-color: #f5f7fa !important;
  border-color: #00557f !important;
  color: #00557f !important;
  transform: translateY(-2px);
  box-shadow: 0 2px 8px rgba(0, 85, 127, 0.1) !important;
}

.custom-unit-dropdown.el-select-dropdown .el-select-dropdown__item.selected {
  background-color: #00557f !important;
  border-color: #00557f !important;
  color: #fff !important;
  font-weight: bold;
}

.custom-unit-dropdown.el-select-dropdown .el-select-dropdown__item.selected:hover {
  background-color: #004266 !important;
  border-color: #004266 !important;
}

.custom-unit-dropdown.el-select-dropdown .el-select-dropdown__item span {
  display: block;
  font-size: 12px;
  line-height: 1.4;
  white-space: normal;
  word-break: break-word;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2; /* 最多显示2行 */
  -webkit-box-orient: vertical;
}

/* 针对不同单位的特定样式 */
.custom-unit-dropdown.el-select-dropdown.pac-unt-dropdown .el-select-dropdown__item {
  background-color: #f9f9f9;
  border-color: #d4e3e9;
}

.custom-unit-dropdown.el-select-dropdown.dos-unt-dropdown .el-select-dropdown__item {
  background-color: #f0f9f9;
  border-color: #b0d4e0;
}

.custom-unit-dropdown.el-select-dropdown.min-unt-dropdown .el-select-dropdown__item {
  background-color: #f5f9f9;
  border-color: #c2e0e8;
}
</style>